import { D as Lt, r as pi, g as hi, u as vi, C as na, a as Hr, c as p, t as O, b as A, I as ia, d as Si, e as oa, P as aa, f as sa, R as w, T as K, i as De, h as ua, j as kr, k as Ue, s as Vr, l as _a } from "./suppress-tracing-DlFr5zkG.js";
import { a as Oi } from "./_commonjsHelpers-DjF3Plf2.js";
typeof NodeList < "u" && !NodeList.prototype[Symbol.iterator] && (NodeList.prototype[Symbol.iterator] = [][Symbol.iterator]);
typeof HTMLCollection < "u" && !HTMLCollection.prototype[Symbol.iterator] && (HTMLCollection.prototype[Symbol.iterator] = [][Symbol.iterator]);
var ca = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ea = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, fa = (
  /** @class */
  function() {
    function t(e) {
      this._entries = e ? new Map(e) : /* @__PURE__ */ new Map();
    }
    return t.prototype.getEntry = function(e) {
      var r = this._entries.get(e);
      if (r)
        return Object.assign({}, r);
    }, t.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(e) {
        var r = ca(e, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, t.prototype.setEntry = function(e, r) {
      var n = new t(this._entries);
      return n._entries.set(e, r), n;
    }, t.prototype.removeEntry = function(e) {
      var r = new t(this._entries);
      return r._entries.delete(e), r;
    }, t.prototype.removeEntries = function() {
      for (var e, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new t(this._entries);
      try {
        for (var a = Ea(n), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          o._entries.delete(u);
        }
      } catch (_) {
        e = { error: _ };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (e) throw e.error;
        }
      }
      return o;
    }, t.prototype.clear = function() {
      return new t();
    }, t;
  }()
), da = Symbol("BaggageEntryMetadata"), la = Lt.instance();
function Ta(t) {
  return t === void 0 && (t = {}), new fa(new Map(Object.entries(t)));
}
function Be(t) {
  return typeof t != "string" && (la.error("Cannot create baggage metadata from unknown type: " + typeof t), t = ""), {
    __TYPE__: da,
    toString: function() {
      return t;
    }
  };
}
var We = [
  { n: "error", c: "error" },
  { n: "warn", c: "warn" },
  { n: "info", c: "info" },
  { n: "debug", c: "debug" },
  { n: "verbose", c: "trace" }
], Ai = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      function e(n) {
        return function() {
          for (var i = [], o = 0; o < arguments.length; o++)
            i[o] = arguments[o];
          if (console) {
            var a = console[n];
            if (typeof a != "function" && (a = console.log), typeof a == "function")
              return a.apply(console, i);
          }
        };
      }
      for (var r = 0; r < We.length; r++)
        this[We[r].n] = e(We[r].c);
    }
    return t;
  }()
), vt = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), pa = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.createGauge = function(e, r) {
      return ya;
    }, t.prototype.createHistogram = function(e, r) {
      return ga;
    }, t.prototype.createCounter = function(e, r) {
      return La;
    }, t.prototype.createUpDownCounter = function(e, r) {
      return Pa;
    }, t.prototype.createObservableGauge = function(e, r) {
      return Ia;
    }, t.prototype.createObservableCounter = function(e, r) {
      return Na;
    }, t.prototype.createObservableUpDownCounter = function(e, r) {
      return ba;
    }, t.prototype.addBatchObservableCallback = function(e, r) {
    }, t.prototype.removeBatchObservableCallback = function(e) {
    }, t;
  }()
), xe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), ha = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n) {
    }, e;
  }(xe)
), va = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n) {
    }, e;
  }(xe)
), Sa = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n) {
    }, e;
  }(xe)
), Oa = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n) {
    }, e;
  }(xe)
), Xr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.addCallback = function(e) {
    }, t.prototype.removeCallback = function(e) {
    }, t;
  }()
), Aa = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(Xr)
), Ra = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(Xr)
), ma = (
  /** @class */
  function(t) {
    vt(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(Xr)
), Ri = new pa(), La = new ha(), ya = new Sa(), ga = new Oa(), Pa = new va(), Na = new Aa(), Ia = new Ra(), ba = new ma();
function Ca() {
  return Ri;
}
var lr;
(function(t) {
  t[t.INT = 0] = "INT", t[t.DOUBLE = 1] = "DOUBLE";
})(lr || (lr = {}));
var mi = {
  get: function(t, e) {
    if (t != null)
      return t[e];
  },
  keys: function(t) {
    return t == null ? [] : Object.keys(t);
  }
}, Li = {
  set: function(t, e, r) {
    t != null && (t[e] = r);
  }
}, nt;
(function(t) {
  t[t.NOT_RECORD = 0] = "NOT_RECORD", t[t.RECORD = 1] = "RECORD", t[t.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(nt || (nt = {}));
var G;
(function(t) {
  t[t.INTERNAL = 0] = "INTERNAL", t[t.SERVER = 1] = "SERVER", t[t.CLIENT = 2] = "CLIENT", t[t.PRODUCER = 3] = "PRODUCER", t[t.CONSUMER = 4] = "CONSUMER";
})(G || (G = {}));
var Zt;
(function(t) {
  t[t.UNSET = 0] = "UNSET", t[t.OK = 1] = "OK", t[t.ERROR = 2] = "ERROR";
})(Zt || (Zt = {}));
var Tr = "[_0-9a-z-*/]", Ma = "[a-z]" + Tr + "{0,255}", wa = "[a-z0-9]" + Tr + "{0,240}@[a-z]" + Tr + "{0,13}", Da = new RegExp("^(?:" + Ma + "|" + wa + ")$"), Ua = /^[ -~]{0,255}[!-~]$/, Ba = /,|=/;
function xa(t) {
  return Da.test(t);
}
function Ga(t) {
  return Ua.test(t) && !Ba.test(t);
}
var cn = 32, Ha = 512, En = ",", fn = "=", ka = (
  /** @class */
  function() {
    function t(e) {
      this._internalState = /* @__PURE__ */ new Map(), e && this._parse(e);
    }
    return t.prototype.set = function(e, r) {
      var n = this._clone();
      return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, r), n;
    }, t.prototype.unset = function(e) {
      var r = this._clone();
      return r._internalState.delete(e), r;
    }, t.prototype.get = function(e) {
      return this._internalState.get(e);
    }, t.prototype.serialize = function() {
      var e = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + fn + e.get(n)), r;
      }, []).join(En);
    }, t.prototype._parse = function(e) {
      e.length > Ha || (this._internalState = e.split(En).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(fn);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, n.length);
          xa(a) && Ga(s) && r.set(a, s);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > cn && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, cn))));
    }, t.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, t.prototype._clone = function() {
      var e = new t();
      return e._internalState = new Map(this._internalState), e;
    }, t;
  }()
);
function Va(t) {
  return new ka(t);
}
var d = Lt.instance(), Xa = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMeter = function(e, r, n) {
      return Ri;
    }, t;
  }()
), $a = new Xa(), ze = "metrics", ja = (
  /** @class */
  function() {
    function t() {
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalMeterProvider = function(e) {
      return pi(ze, e, Lt.instance());
    }, t.prototype.getMeterProvider = function() {
      return hi(ze) || $a;
    }, t.prototype.getMeter = function(e, r, n) {
      return this.getMeterProvider().getMeter(e, r, n);
    }, t.prototype.disable = function() {
      vi(ze, Lt.instance());
    }, t;
  }()
), Ge = ja.getInstance(), Fa = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r) {
    }, t.prototype.extract = function(e, r) {
      return e;
    }, t.prototype.fields = function() {
      return [];
    }, t;
  }()
), $r = Hr("OpenTelemetry Baggage Key");
function yi(t) {
  return t.getValue($r) || void 0;
}
function Ka() {
  return yi(na.getInstance().active());
}
function Ya(t, e) {
  return t.setValue($r, e);
}
function Wa(t) {
  return t.deleteValue($r);
}
var Ze = "propagation", za = new Fa(), Za = (
  /** @class */
  function() {
    function t() {
      this.createBaggage = Ta, this.getBaggage = yi, this.getActiveBaggage = Ka, this.setBaggage = Ya, this.deleteBaggage = Wa;
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalPropagator = function(e) {
      return pi(Ze, e, Lt.instance());
    }, t.prototype.inject = function(e, r, n) {
      return n === void 0 && (n = Li), this._getGlobalPropagator().inject(e, r, n);
    }, t.prototype.extract = function(e, r, n) {
      return n === void 0 && (n = mi), this._getGlobalPropagator().extract(e, r, n);
    }, t.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, t.prototype.disable = function() {
      vi(Ze, Lt.instance());
    }, t.prototype._getGlobalPropagator = function() {
      return hi(Ze) || za;
    }, t;
  }()
), I = Za.getInstance();
const qa = {
  context: p,
  diag: d,
  metrics: Ge,
  propagation: I,
  trace: O
}, Ja = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DiagConsoleLogger: Ai,
  get DiagLogLevel() {
    return A;
  },
  INVALID_SPANID: ia,
  INVALID_SPAN_CONTEXT: Si,
  INVALID_TRACEID: oa,
  ProxyTracer: aa,
  ProxyTracerProvider: sa,
  ROOT_CONTEXT: w,
  get SamplingDecision() {
    return nt;
  },
  get SpanKind() {
    return G;
  },
  get SpanStatusCode() {
    return Zt;
  },
  get TraceFlags() {
    return K;
  },
  get ValueType() {
    return lr;
  },
  baggageEntryMetadataFromString: Be,
  context: p,
  createContextKey: Hr,
  createNoopMeter: Ca,
  createTraceState: Va,
  default: qa,
  defaultTextMapGetter: mi,
  defaultTextMapSetter: Li,
  diag: d,
  isSpanContextValid: De,
  isValidSpanId: ua,
  isValidTraceId: kr,
  metrics: Ge,
  propagation: I,
  trace: O
}, Symbol.toStringTag, { value: "Module" }));
var Qa = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.emit = function(e) {
    }, t;
  }()
), ts = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      return new Qa();
    }, t;
  }()
), dn = new ts(), es = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ie = Symbol.for("io.opentelemetry.js.api.logs"), Ct = es;
function rs(t, e, r) {
  return function(n) {
    return n === t ? e : r;
  };
}
var ln = 1, ns = (
  /** @class */
  function() {
    function t() {
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalLoggerProvider = function(e) {
      return Ct[ie] ? this.getLoggerProvider() : (Ct[ie] = rs(ln, e, dn), e);
    }, t.prototype.getLoggerProvider = function() {
      var e, r;
      return (r = (e = Ct[ie]) === null || e === void 0 ? void 0 : e.call(Ct, ln)) !== null && r !== void 0 ? r : dn;
    }, t.prototype.getLogger = function(e, r, n) {
      return this.getLoggerProvider().getLogger(e, r, n);
    }, t.prototype.disable = function() {
      delete Ct[ie];
    }, t;
  }()
), gi = ns.getInstance();
function is(t, e, r, n) {
  for (var i = 0, o = t.length; i < o; i++) {
    var a = t[i];
    e && a.setTracerProvider(e), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function os(t) {
  t.forEach(function(e) {
    return e.disable();
  });
}
function as(t) {
  var e, r, n = t.tracerProvider || O.getTracerProvider(), i = t.meterProvider || Ge.getMeterProvider(), o = t.loggerProvider || gi.getLoggerProvider(), a = (r = (e = t.instrumentations) === null || e === void 0 ? void 0 : e.flat()) !== null && r !== void 0 ? r : [];
  return is(a, n, i, o), function() {
    os(a);
  };
}
function pr(t) {
  return typeof t == "function";
}
var b = console.error.bind(console);
function Mt(t, e, r) {
  var n = !!t[e] && t.propertyIsEnumerable(e);
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function re(t) {
  t && t.logger && (pr(t.logger) ? b = t.logger : b("new logger isn't a function, not replacing"));
}
function Pi(t, e, r) {
  if (!t || !t[e]) {
    b("no original function " + e + " to wrap");
    return;
  }
  if (!r) {
    b("no wrapper function"), b(new Error().stack);
    return;
  }
  if (!pr(t[e]) || !pr(r)) {
    b("original object and wrapper must be functions");
    return;
  }
  var n = t[e], i = r(n, e);
  return Mt(i, "__original", n), Mt(i, "__unwrap", function() {
    t[e] === i && Mt(t, e, n);
  }), Mt(i, "__wrapped", !0), Mt(t, e, i), i;
}
function ss(t, e, r) {
  if (t)
    Array.isArray(t) || (t = [t]);
  else {
    b("must provide one or more modules to patch"), b(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    b("must provide one or more functions to wrap on modules");
    return;
  }
  t.forEach(function(n) {
    e.forEach(function(i) {
      Pi(n, i, r);
    });
  });
}
function Ni(t, e) {
  if (!t || !t[e]) {
    b("no function to unwrap."), b(new Error().stack);
    return;
  }
  if (!t[e].__unwrap)
    b("no original to unwrap to -- has " + e + " already been unwrapped?");
  else
    return t[e].__unwrap();
}
function us(t, e) {
  if (t)
    Array.isArray(t) || (t = [t]);
  else {
    b("must provide one or more modules to patch"), b(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    b("must provide one or more functions to unwrap on modules");
    return;
  }
  t.forEach(function(r) {
    e.forEach(function(n) {
      Ni(r, n);
    });
  });
}
re.wrap = Pi;
re.massWrap = ss;
re.unwrap = Ni;
re.massUnwrap = us;
var y = re, Se = function() {
  return Se = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Se.apply(this, arguments);
}, _s = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.instrumentationName = e, this.instrumentationVersion = r, this._wrap = y.wrap, this._unwrap = y.unwrap, this._massWrap = y.massWrap, this._massUnwrap = y.massUnwrap, this._config = Se({ enabled: !0 }, n), this._diag = d.createComponentLogger({
        namespace: e
      }), this._tracer = O.getTracer(e, r), this._meter = Ge.getMeter(e, r), this._logger = gi.getLogger(e, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(t.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(t.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, t.prototype.getModuleDefinitions = function() {
      var e, r = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(r) ? r : [r];
    }, t.prototype._updateMetricInstruments = function() {
    }, t.prototype.getConfig = function() {
      return this._config;
    }, t.prototype.setConfig = function(e) {
      this._config = Se({}, e);
    }, t.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(t.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._runSpanCustomizationHook = function(e, r, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, t;
  }()
), cs = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), j = (
  /** @class */
  function(t) {
    cs(e, t);
    function e(r, n, i) {
      var o = t.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return e;
  }(_s)
);
function Oe(t, e, r) {
  var n, i;
  try {
    i = t();
  } catch (o) {
    n = o;
  } finally {
    if (e(n, i), n && !r)
      throw n;
    return i;
  }
}
function B(t) {
  return typeof t == "function" && typeof t.__original == "function" && typeof t.__unwrap == "function" && t.__wrapped === !0;
}
var Es = "=", hr = ";", Ae = ",", qe = "baggage", fs = 180, ds = 4096, ls = 8192, Ts = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ii(t) {
  return t.reduce(function(e, r) {
    var n = "" + e + (e !== "" ? Ae : "") + r;
    return n.length > ls ? e : n;
  }, "");
}
function bi(t) {
  return t.getAllEntries().map(function(e) {
    var r = Ts(e, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += hr + i.metadata.toString()), o;
  });
}
function jr(t) {
  var e = t.split(hr);
  if (!(e.length <= 0)) {
    var r = e.shift();
    if (r) {
      var n = r.indexOf(Es);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return e.length > 0 && (a = Be(e.join(hr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
function ps(t) {
  return typeof t != "string" || t.length === 0 ? {} : t.split(Ae).map(function(e) {
    return jr(e);
  }).filter(function(e) {
    return e !== void 0 && e.value.length > 0;
  }).reduce(function(e, r) {
    return e[r.key] = r.value, e;
  }, {});
}
var Ci = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r, n) {
      var i = I.getBaggage(e);
      if (!(!i || Ue(e))) {
        var o = bi(i).filter(function(s) {
          return s.length <= ds;
        }).slice(0, fs), a = Ii(o);
        a.length > 0 && n.set(r, qe, a);
      }
    }, t.prototype.extract = function(e, r, n) {
      var i = n.get(r, qe), o = Array.isArray(i) ? i.join(Ae) : i;
      if (!o)
        return e;
      var a = {};
      if (o.length === 0)
        return e;
      var s = o.split(Ae);
      return s.forEach(function(u) {
        var _ = jr(u);
        if (_) {
          var c = { value: _.value };
          _.metadata && (c.metadata = _.metadata), a[_.key] = c;
        }
      }), Object.entries(a).length === 0 ? e : I.setBaggage(e, I.createBaggage(a));
    }, t.prototype.fields = function() {
      return [qe];
    }, t;
  }()
), hs = (
  /** @class */
  function() {
    function t(e, r) {
      this._monotonicClock = r, this._epochMillis = e.now(), this._performanceMillis = r.now();
    }
    return t.prototype.now = function() {
      var e = this._monotonicClock.now() - this._performanceMillis;
      return this._epochMillis + e;
    }, t;
  }()
), Mi = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, vs = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function kt(t) {
  var e, r, n = {};
  if (typeof t != "object" || t == null)
    return n;
  try {
    for (var i = Mi(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
      var a = vs(o.value, 2), s = a[0], u = a[1];
      if (!wi(s)) {
        d.warn("Invalid attribute key: " + s);
        continue;
      }
      if (!Fr(u)) {
        d.warn("Invalid attribute value set for key: " + s);
        continue;
      }
      Array.isArray(u) ? n[s] = u.slice() : n[s] = u;
    }
  } catch (_) {
    e = { error: _ };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function wi(t) {
  return typeof t == "string" && t.length > 0;
}
function Fr(t) {
  return t == null ? !0 : Array.isArray(t) ? Ss(t) : Di(t);
}
function Ss(t) {
  var e, r, n;
  try {
    for (var i = Mi(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Di(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (s) {
    e = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return !0;
}
function Di(t) {
  switch (typeof t) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Ui() {
  return function(t) {
    d.error(Os(t));
  };
}
function Os(t) {
  return typeof t == "string" ? t : JSON.stringify(As(t));
}
function As(t) {
  for (var e = {}, r = t; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!e[n]) {
        var i = r[n];
        i && (e[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return e;
}
var Bi = Ui();
function Rs(t) {
  Bi = t;
}
function X(t) {
  try {
    Bi(t);
  } catch {
  }
}
var k;
(function(t) {
  t.AlwaysOff = "always_off", t.AlwaysOn = "always_on", t.ParentBasedAlwaysOff = "parentbased_always_off", t.ParentBasedAlwaysOn = "parentbased_always_on", t.ParentBasedTraceIdRatio = "parentbased_traceidratio", t.TraceIdRatio = "traceidratio";
})(k || (k = {}));
var ms = ",", Ls = ["OTEL_SDK_DISABLED"];
function ys(t) {
  return Ls.indexOf(t) > -1;
}
var gs = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Ps(t) {
  return gs.indexOf(t) > -1;
}
var Ns = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Is(t) {
  return Ns.indexOf(t) > -1;
}
var Vt = 1 / 0, Xt = 128, xi = 128, Gi = 128, Kr = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: A.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Vt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Xt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Vt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Xt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Vt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Xt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: xi,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Gi,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: k.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function bs(t, e, r) {
  if (!(typeof r[t] > "u")) {
    var n = String(r[t]);
    e[t] = n.toLowerCase() === "true";
  }
}
function Cs(t, e, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[t] < "u") {
    var o = Number(r[t]);
    isNaN(o) || (o < n ? e[t] = n : o > i ? e[t] = i : e[t] = o);
  }
}
function Ms(t, e, r, n) {
  n === void 0 && (n = ms);
  var i = r[t];
  typeof i == "string" && (e[t] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var ws = {
  ALL: A.ALL,
  VERBOSE: A.VERBOSE,
  DEBUG: A.DEBUG,
  INFO: A.INFO,
  WARN: A.WARN,
  ERROR: A.ERROR,
  NONE: A.NONE
};
function Ds(t, e, r) {
  var n = r[t];
  if (typeof n == "string") {
    var i = ws[n.toUpperCase()];
    i != null && (e[t] = i);
  }
}
function Yr(t) {
  var e = {};
  for (var r in Kr) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Ds(n, e, t);
        break;
      default:
        if (ys(n))
          bs(n, e, t);
        else if (Ps(n))
          Cs(n, e, t);
        else if (Is(n))
          Ms(n, e, t);
        else {
          var i = t[n];
          typeof i < "u" && i !== null && (e[n] = String(i));
        }
    }
  }
  return e;
}
var qt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function yt() {
  var t = Yr(qt);
  return Object.assign({}, Kr, t);
}
function Hi() {
  return Yr(qt);
}
function Tn(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 97 && t <= 102 ? t - 87 : t - 55;
}
function ki(t) {
  for (var e = new Uint8Array(t.length / 2), r = 0, n = 0; n < t.length; n += 2) {
    var i = Tn(t.charCodeAt(n)), o = Tn(t.charCodeAt(n + 1));
    e[r++] = i << 4 | o;
  }
  return e;
}
var Us = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Bs = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
};
function xs(t) {
  return btoa(String.fromCharCode.apply(String, Bs([], Us(ki(t)), !1)));
}
var Gs = 8, Hs = 16, ks = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.generateTraceId = pn(Hs), this.generateSpanId = pn(Gs);
    }
    return t;
  }()
), oe = Array(32);
function pn(t) {
  return function() {
    for (var r = 0; r < t * 2; r++)
      oe[r] = Math.floor(Math.random() * 16) + 48, oe[r] >= 58 && (oe[r] += 39);
    return String.fromCharCode.apply(null, oe.slice(0, t * 2));
  };
}
var $ = performance, Vi = "1.30.1", Vs = "process.runtime.name", Xs = "telemetry.sdk.name", $s = "telemetry.sdk.language", js = "telemetry.sdk.version", Fs = Vs, Ks = Xs, Ys = $s, Ws = js, zs = "webjs", Zs = zs, St, $t = (St = {}, St[Ks] = "opentelemetry", St[Fs] = "browser", St[Ys] = Zs, St[Ws] = Vi, St);
function qs(t) {
}
var Xi = 9, Js = 6, Qs = Math.pow(10, Js), Re = Math.pow(10, Xi);
function tt(t) {
  var e = t / 1e3, r = Math.trunc(e), n = Math.round(t % 1e3 * Qs);
  return [r, n];
}
function He() {
  var t = $.timeOrigin;
  if (typeof t != "number") {
    var e = $;
    t = e.timing && e.timing.fetchStart;
  }
  return t;
}
function Wr(t) {
  var e = tt(He()), r = tt(typeof t == "number" ? t : $.now());
  return zr(e, r);
}
function tu(t) {
  if (ke(t))
    return t;
  if (typeof t == "number")
    return t < He() ? Wr(t) : tt(t);
  if (t instanceof Date)
    return tt(t.getTime());
  throw TypeError("Invalid input type");
}
function $i(t, e) {
  var r = e[0] - t[0], n = e[1] - t[1];
  return n < 0 && (r -= 1, n += Re), [r, n];
}
function eu(t) {
  var e = Xi, r = "" + "0".repeat(e) + t[1] + "Z", n = r.substring(r.length - e - 1), i = new Date(t[0] * 1e3).toISOString();
  return i.replace("000Z", n);
}
function ru(t) {
  return t[0] * Re + t[1];
}
function nu(t) {
  return t[0] * 1e3 + t[1] / 1e6;
}
function vr(t) {
  return t[0] * 1e6 + t[1] / 1e3;
}
function ke(t) {
  return Array.isArray(t) && t.length === 2 && typeof t[0] == "number" && typeof t[1] == "number";
}
function Sr(t) {
  return ke(t) || typeof t == "number" || t instanceof Date;
}
function zr(t, e) {
  var r = [t[0] + e[0], t[1] + e[1]];
  return r[1] >= Re && (r[1] -= Re, r[0] += 1), r;
}
var ht;
(function(t) {
  t[t.SUCCESS = 0] = "SUCCESS", t[t.FAILED = 1] = "FAILED";
})(ht || (ht = {}));
var iu = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ji = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {});
      var r;
      this._propagators = (r = e.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return t.prototype.inject = function(e, r, n) {
      var i, o;
      try {
        for (var a = iu(this._propagators), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          try {
            u.inject(e, r, n);
          } catch (_) {
            d.warn("Failed to inject with " + u.constructor.name + ". Err: " + _.message);
          }
        }
      } catch (_) {
        i = { error: _ };
      } finally {
        try {
          s && !s.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, t.prototype.extract = function(e, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          d.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, e);
    }, t.prototype.fields = function() {
      return this._fields.slice();
    }, t;
  }()
), Or = "[_0-9a-z-*/]", ou = "[a-z]" + Or + "{0,255}", au = "[a-z0-9]" + Or + "{0,240}@[a-z]" + Or + "{0,13}", su = new RegExp("^(?:" + ou + "|" + au + ")$"), uu = /^[ -~]{0,255}[!-~]$/, _u = /,|=/;
function cu(t) {
  return su.test(t);
}
function Eu(t) {
  return uu.test(t) && !_u.test(t);
}
var hn = 32, fu = 512, vn = ",", Sn = "=", Fi = (
  /** @class */
  function() {
    function t(e) {
      this._internalState = /* @__PURE__ */ new Map(), e && this._parse(e);
    }
    return t.prototype.set = function(e, r) {
      var n = this._clone();
      return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, r), n;
    }, t.prototype.unset = function(e) {
      var r = this._clone();
      return r._internalState.delete(e), r;
    }, t.prototype.get = function(e) {
      return this._internalState.get(e);
    }, t.prototype.serialize = function() {
      var e = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Sn + e.get(n)), r;
      }, []).join(vn);
    }, t.prototype._parse = function(e) {
      e.length > fu || (this._internalState = e.split(vn).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Sn);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, n.length);
          cu(a) && Eu(s) && r.set(a, s);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > hn && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, hn))));
    }, t.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, t.prototype._clone = function() {
      var e = new t();
      return e._internalState = new Map(this._internalState), e;
    }, t;
  }()
), jt = "traceparent", de = "tracestate", du = "00", lu = "(?!ff)[\\da-f]{2}", Tu = "(?![0]{32})[\\da-f]{32}", pu = "(?![0]{16})[\\da-f]{16}", hu = "[\\da-f]{2}", vu = new RegExp("^\\s?(" + lu + ")-(" + Tu + ")-(" + pu + ")-(" + hu + ")(-.*)?\\s?$");
function Ki(t) {
  var e = vu.exec(t);
  return !e || e[1] === "00" && e[5] ? null : {
    traceId: e[2],
    spanId: e[3],
    traceFlags: parseInt(e[4], 16)
  };
}
var Yi = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r, n) {
      var i = O.getSpanContext(e);
      if (!(!i || Ue(e) || !De(i))) {
        var o = du + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || K.NONE).toString(16);
        n.set(r, jt, o), i.traceState && n.set(r, de, i.traceState.serialize());
      }
    }, t.prototype.extract = function(e, r, n) {
      var i = n.get(r, jt);
      if (!i)
        return e;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return e;
      var a = Ki(o);
      if (!a)
        return e;
      a.isRemote = !0;
      var s = n.get(r, de);
      if (s) {
        var u = Array.isArray(s) ? s.join(",") : s;
        a.traceState = new Fi(typeof u == "string" ? u : void 0);
      }
      return O.setSpanContext(e, a);
    }, t.prototype.fields = function() {
      return [jt, de];
    }, t;
  }()
), Zr = Hr("OpenTelemetry SDK Context Key RPC_METADATA"), Ar;
(function(t) {
  t.HTTP = "http";
})(Ar || (Ar = {}));
function Su(t, e) {
  return t.setValue(Zr, e);
}
function Ou(t) {
  return t.deleteValue(Zr);
}
function Au(t) {
  return t.getValue(Zr);
}
var Rr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: nt.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, t;
  }()
), le = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: nt.RECORD_AND_SAMPLED
      };
    }, t.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, t;
  }()
), Ru = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o;
      this._root = e.root, this._root || (X(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new le()), this._remoteParentSampled = (r = e.remoteParentSampled) !== null && r !== void 0 ? r : new le(), this._remoteParentNotSampled = (n = e.remoteParentNotSampled) !== null && n !== void 0 ? n : new Rr(), this._localParentSampled = (i = e.localParentSampled) !== null && i !== void 0 ? i : new le(), this._localParentNotSampled = (o = e.localParentNotSampled) !== null && o !== void 0 ? o : new Rr();
    }
    return t.prototype.shouldSample = function(e, r, n, i, o, a) {
      var s = O.getSpanContext(e);
      return !s || !De(s) ? this._root.shouldSample(e, r, n, i, o, a) : s.isRemote ? s.traceFlags & K.SAMPLED ? this._remoteParentSampled.shouldSample(e, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(e, r, n, i, o, a) : s.traceFlags & K.SAMPLED ? this._localParentSampled.shouldSample(e, r, n, i, o, a) : this._localParentNotSampled.shouldSample(e, r, n, i, o, a);
    }, t.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, t;
  }()
), mu = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = 0), this._ratio = e, this._ratio = this._normalize(e), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return t.prototype.shouldSample = function(e, r) {
      return {
        decision: kr(r) && this._accumulate(r) < this._upperBound ? nt.RECORD_AND_SAMPLED : nt.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, t.prototype._normalize = function(e) {
      return typeof e != "number" || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }, t.prototype._accumulate = function(e) {
      for (var r = 0, n = 0; n < e.length / 8; n++) {
        var i = n * 8, o = parseInt(e.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, t;
  }()
), Lu = "[object Object]", yu = "[object Null]", gu = "[object Undefined]", Pu = Function.prototype, Wi = Pu.toString, Nu = Wi.call(Object), Iu = bu(Object.getPrototypeOf, Object), zi = Object.prototype, Zi = zi.hasOwnProperty, dt = Symbol ? Symbol.toStringTag : void 0, qi = zi.toString;
function bu(t, e) {
  return function(r) {
    return t(e(r));
  };
}
function On(t) {
  if (!Cu(t) || Mu(t) !== Lu)
    return !1;
  var e = Iu(t);
  if (e === null)
    return !0;
  var r = Zi.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Wi.call(r) === Nu;
}
function Cu(t) {
  return t != null && typeof t == "object";
}
function Mu(t) {
  return t == null ? t === void 0 ? gu : yu : dt && dt in Object(t) ? wu(t) : Du(t);
}
function wu(t) {
  var e = Zi.call(t, dt), r = t[dt], n = !1;
  try {
    t[dt] = void 0, n = !0;
  } catch {
  }
  var i = qi.call(t);
  return n && (e ? t[dt] = r : delete t[dt]), i;
}
function Du(t) {
  return qi.call(t);
}
var Uu = 20;
function Ji() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var r = t.shift(), n = /* @__PURE__ */ new WeakMap(); t.length > 0; )
    r = Qi(r, t.shift(), 0, n);
  return r;
}
function Je(t) {
  return me(t) ? t.slice() : t;
}
function Qi(t, e, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Uu)) {
    if (r++, Te(t) || Te(e) || to(e))
      i = Je(e);
    else if (me(t)) {
      if (i = t.slice(), me(e))
        for (var o = 0, a = e.length; o < a; o++)
          i.push(Je(e[o]));
      else if (wt(e))
        for (var s = Object.keys(e), o = 0, a = s.length; o < a; o++) {
          var u = s[o];
          i[u] = Je(e[u]);
        }
    } else if (wt(t))
      if (wt(e)) {
        if (!Bu(t, e))
          return e;
        i = Object.assign({}, t);
        for (var s = Object.keys(e), o = 0, a = s.length; o < a; o++) {
          var u = s[o], _ = e[u];
          if (Te(_))
            typeof _ > "u" ? delete i[u] : i[u] = _;
          else {
            var c = i[u], E = _;
            if (An(t, u, n) || An(e, u, n))
              delete i[u];
            else {
              if (wt(c) && wt(E)) {
                var f = n.get(c) || [], T = n.get(E) || [];
                f.push({ obj: t, key: u }), T.push({ obj: e, key: u }), n.set(c, f), n.set(E, T);
              }
              i[u] = Qi(i[u], _, r, n);
            }
          }
        }
      } else
        i = e;
    return i;
  }
}
function An(t, e, r) {
  for (var n = r.get(t[e]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === e && a.obj === t)
      return !0;
  }
  return !1;
}
function me(t) {
  return Array.isArray(t);
}
function to(t) {
  return typeof t == "function";
}
function wt(t) {
  return !Te(t) && !me(t) && !to(t) && typeof t == "object";
}
function Te(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t > "u" || t instanceof Date || t instanceof RegExp || t === null;
}
function Bu(t, e) {
  return !(!On(t) || !On(e));
}
var xu = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), eo = (
  /** @class */
  function(t) {
    xu(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return Object.setPrototypeOf(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function Gu(t, e) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new eo("Operation timed out."));
    }, e);
  });
  return Promise.race([t, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
var Hu = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ro(t, e) {
  return typeof e == "string" ? t === e : !!t.match(e);
}
function Ve(t, e) {
  var r, n;
  if (!e)
    return !1;
  try {
    for (var i = Hu(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (ro(t, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
function ku(t) {
  return typeof t == "function" && typeof t.__original == "function" && typeof t.__unwrap == "function" && t.__wrapped === !0;
}
var Vu = (
  /** @class */
  function() {
    function t() {
      var e = this;
      this._promise = new Promise(function(r, n) {
        e._resolve = r, e._reject = n;
      });
    }
    return Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolve = function(e) {
      this._resolve(e);
    }, t.prototype.reject = function(e) {
      this._reject(e);
    }, t;
  }()
), Xu = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, $u = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, qr = (
  /** @class */
  function() {
    function t(e, r) {
      this._callback = e, this._that = r, this._isCalled = !1, this._deferred = new Vu();
    }
    return Object.defineProperty(t.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.call = function() {
      for (var e, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((e = this._callback).call.apply(e, $u([this._that], Xu(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, t;
  }()
);
function ju(t, e) {
  return new Promise(function(r) {
    p.with(Vr(p.active()), function() {
      t.export(e, function(n) {
        r(n);
      });
    });
  });
}
var Fu = {
  getKeyPairs: bi,
  serializeKeyPairs: Ii,
  parseKeyPairsIntoRecord: ps,
  parsePairKeyValue: jr
}, no = {
  _export: ju
};
const Ku = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlwaysOffSampler: Rr,
  AlwaysOnSampler: le,
  AnchoredClock: hs,
  BindOnceFuture: qr,
  CompositePropagator: ji,
  DEFAULT_ATTRIBUTE_COUNT_LIMIT: Xt,
  DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT: Vt,
  DEFAULT_ENVIRONMENT: Kr,
  DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: xi,
  DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Gi,
  get ExportResultCode() {
    return ht;
  },
  ParentBasedSampler: Ru,
  get RPCType() {
    return Ar;
  },
  RandomIdGenerator: ks,
  SDK_INFO: $t,
  TRACE_PARENT_HEADER: jt,
  TRACE_STATE_HEADER: de,
  TimeoutError: eo,
  TraceIdRatioBasedSampler: mu,
  TraceState: Fi,
  get TracesSamplerValues() {
    return k;
  },
  VERSION: Vi,
  W3CBaggagePropagator: Ci,
  W3CTraceContextPropagator: Yi,
  _globalThis: qt,
  addHrTimes: zr,
  baggageUtils: Fu,
  callWithTimeout: Gu,
  deleteRPCMetadata: Ou,
  getEnv: yt,
  getEnvWithoutDefaults: Hi,
  getRPCMetadata: Au,
  getTimeOrigin: He,
  globalErrorHandler: X,
  hexToBase64: xs,
  hexToBinary: ki,
  hrTime: Wr,
  hrTimeDuration: $i,
  hrTimeToMicroseconds: vr,
  hrTimeToMilliseconds: nu,
  hrTimeToNanoseconds: ru,
  hrTimeToTimeStamp: eu,
  internal: no,
  isAttributeKey: wi,
  isAttributeValue: Fr,
  isTimeInput: Sr,
  isTimeInputHrTime: ke,
  isTracingSuppressed: Ue,
  isUrlIgnored: Ve,
  isWrapped: ku,
  loggingErrorHandler: Ui,
  merge: Ji,
  millisToHrTime: tt,
  otperformance: $,
  parseEnvironment: Yr,
  parseTraceParent: Ki,
  sanitizeAttributes: kt,
  setGlobalErrorHandler: Rs,
  setRPCMetadata: Su,
  suppressTracing: Vr,
  timeInputToHrTime: tu,
  unrefTimer: qs,
  unsuppressTracing: _a,
  urlMatches: ro
}, Symbol.toStringTag, { value: "Module" }));
var Yu = "exception.type", Wu = "exception.message", zu = "exception.stacktrace", Qe = Yu, tr = Wu, Zu = zu, qu = "exception", mr = function() {
  return mr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, mr.apply(this, arguments);
}, Ju = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rn = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qu = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, t_ = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, _, c) {
      s === void 0 && (s = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Zt.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = s;
      var E = Date.now();
      this._performanceStartTime = $.now(), this._performanceOffset = E - (this._performanceStartTime + He()), this._startTimeProvided = u != null, this.startTime = this._getTime(u ?? E), this.resource = e.resource, this.instrumentationLibrary = e.instrumentationLibrary, this._spanLimits = e.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, c != null && this.setAttributes(c), this._spanProcessor = e.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return t.prototype.spanContext = function() {
      return this._spanContext;
    }, t.prototype.setAttribute = function(e, r) {
      return r == null || this._isSpanEnded() ? this : e.length === 0 ? (d.warn("Invalid attribute key: " + e), this) : Fr(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, e) ? (this._droppedAttributesCount++, this) : (this.attributes[e] = this._truncateToSize(r), this) : (d.warn("Invalid attribute value set for key: " + e), this);
    }, t.prototype.setAttributes = function(e) {
      var r, n;
      try {
        for (var i = Ju(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
          var a = Rn(o.value, 2), s = a[0], u = a[1];
          this.setAttribute(s, u);
        }
      } catch (_) {
        r = { error: _ };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, t.prototype.addEvent = function(e, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return d.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && d.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Sr(r) && (Sr(n) || (n = r), r = void 0);
      var i = kt(r);
      return this.events.push({
        name: e,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, t.prototype.addLink = function(e) {
      return this.links.push(e), this;
    }, t.prototype.addLinks = function(e) {
      var r;
      return (r = this.links).push.apply(r, Qu([], Rn(e), !1)), this;
    }, t.prototype.setStatus = function(e) {
      return this._isSpanEnded() ? this : (this.status = mr({}, e), this.status.message != null && typeof e.message != "string" && (d.warn("Dropping invalid status.message of type '" + typeof e.message + "', expected 'string'"), delete this.status.message), this);
    }, t.prototype.updateName = function(e) {
      return this._isSpanEnded() ? this : (this.name = e, this);
    }, t.prototype.end = function(e) {
      if (this._isSpanEnded()) {
        d.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(e), this._duration = $i(this.startTime, this.endTime), this._duration[0] < 0 && (d.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && d.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, t.prototype._getTime = function(e) {
      if (typeof e == "number" && e <= $.now())
        return Wr(e + this._performanceOffset);
      if (typeof e == "number")
        return tt(e);
      if (e instanceof Date)
        return tt(e.getTime());
      if (ke(e))
        return e;
      if (this._startTimeProvided)
        return tt(Date.now());
      var r = $.now() - this._performanceStartTime;
      return zr(this.startTime, tt(r));
    }, t.prototype.isRecording = function() {
      return this._ended === !1;
    }, t.prototype.recordException = function(e, r) {
      var n = {};
      typeof e == "string" ? n[tr] = e : e && (e.code ? n[Qe] = e.code.toString() : e.name && (n[Qe] = e.name), e.message && (n[tr] = e.message), e.stack && (n[Zu] = e.stack)), n[Qe] || n[tr] ? this.addEvent(qu, n, r) : d.warn("Failed to record an exception " + e);
    }, Object.defineProperty(t.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._isSpanEnded = function() {
      return this._ended && d.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, t.prototype._truncateToLimitUtil = function(e, r) {
      return e.length <= r ? e : e.substring(0, r);
    }, t.prototype._truncateToSize = function(e) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (d.warn("Attribute value limit must be positive, got " + n), e) : typeof e == "string" ? this._truncateToLimitUtil(e, n) : Array.isArray(e) ? e.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : e;
    }, t;
  }()
), gt;
(function(t) {
  t[t.NOT_RECORD = 0] = "NOT_RECORD", t[t.RECORD = 1] = "RECORD", t[t.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(gt || (gt = {}));
var Pt = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: gt.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, t;
  }()
), rt = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: gt.RECORD_AND_SAMPLED
      };
    }, t.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, t;
  }()
), pe = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o;
      this._root = e.root, this._root || (X(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new rt()), this._remoteParentSampled = (r = e.remoteParentSampled) !== null && r !== void 0 ? r : new rt(), this._remoteParentNotSampled = (n = e.remoteParentNotSampled) !== null && n !== void 0 ? n : new Pt(), this._localParentSampled = (i = e.localParentSampled) !== null && i !== void 0 ? i : new rt(), this._localParentNotSampled = (o = e.localParentNotSampled) !== null && o !== void 0 ? o : new Pt();
    }
    return t.prototype.shouldSample = function(e, r, n, i, o, a) {
      var s = O.getSpanContext(e);
      return !s || !De(s) ? this._root.shouldSample(e, r, n, i, o, a) : s.isRemote ? s.traceFlags & K.SAMPLED ? this._remoteParentSampled.shouldSample(e, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(e, r, n, i, o, a) : s.traceFlags & K.SAMPLED ? this._localParentSampled.shouldSample(e, r, n, i, o, a) : this._localParentNotSampled.shouldSample(e, r, n, i, o, a);
    }, t.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, t;
  }()
), mn = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = 0), this._ratio = e, this._ratio = this._normalize(e), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return t.prototype.shouldSample = function(e, r) {
      return {
        decision: kr(r) && this._accumulate(r) < this._upperBound ? gt.RECORD_AND_SAMPLED : gt.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, t.prototype._normalize = function(e) {
      return typeof e != "number" || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }, t.prototype._accumulate = function(e) {
      for (var r = 0, n = 0; n < e.length / 8; n++) {
        var i = n * 8, o = parseInt(e.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, t;
  }()
), e_ = k.AlwaysOn, Ot = 1;
function io() {
  var t = yt();
  return {
    sampler: oo(t),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: t.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: t.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: t.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: t.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: t.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: t.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: t.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: t.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function oo(t) {
  switch (t === void 0 && (t = yt()), t.OTEL_TRACES_SAMPLER) {
    case k.AlwaysOn:
      return new rt();
    case k.AlwaysOff:
      return new Pt();
    case k.ParentBasedAlwaysOn:
      return new pe({
        root: new rt()
      });
    case k.ParentBasedAlwaysOff:
      return new pe({
        root: new Pt()
      });
    case k.TraceIdRatio:
      return new mn(Ln(t));
    case k.ParentBasedTraceIdRatio:
      return new pe({
        root: new mn(Ln(t))
      });
    default:
      return d.error('OTEL_TRACES_SAMPLER value "' + t.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + e_ + '".'), new rt();
  }
}
function Ln(t) {
  if (t.OTEL_TRACES_SAMPLER_ARG === void 0 || t.OTEL_TRACES_SAMPLER_ARG === "")
    return d.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Ot + "."), Ot;
  var e = Number(t.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(e) ? (d.error("OTEL_TRACES_SAMPLER_ARG=" + t.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Ot + "."), Ot) : e < 0 || e > 1 ? (d.error("OTEL_TRACES_SAMPLER_ARG=" + t.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Ot + "."), Ot) : e;
}
function r_(t) {
  var e = {
    sampler: oo()
  }, r = io(), n = Object.assign({}, r, e, t);
  return n.generalLimits = Object.assign({}, r.generalLimits, t.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, t.spanLimits || {}), n;
}
function n_(t) {
  var e, r, n, i, o, a, s, u, _, c, E, f, T = Object.assign({}, t.spanLimits), l = Hi();
  return T.attributeCountLimit = (a = (o = (i = (r = (e = t.spanLimits) === null || e === void 0 ? void 0 : e.attributeCountLimit) !== null && r !== void 0 ? r : (n = t.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : l.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : l.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Xt, T.attributeValueLengthLimit = (f = (E = (c = (u = (s = t.spanLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && u !== void 0 ? u : (_ = t.generalLimits) === null || _ === void 0 ? void 0 : _.attributeValueLengthLimit) !== null && c !== void 0 ? c : l.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && E !== void 0 ? E : l.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : Vt, Object.assign({}, t, { spanLimits: T });
}
var i_ = (
  /** @class */
  function() {
    function t(e, r) {
      this._exporter = e, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = yt();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new qr(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (d.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return t.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, t.prototype.onStart = function(e, r) {
    }, t.prototype.onEnd = function(e) {
      this._shutdownOnce.isCalled || e.spanContext().traceFlags & K.SAMPLED && this._addToBuffer(e);
    }, t.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, t.prototype._shutdown = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.onShutdown();
      }).then(function() {
        return e._flushAll();
      }).then(function() {
        return e._exporter.shutdown();
      });
    }, t.prototype._addToBuffer = function(e) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && d.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (d.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(e), this._maybeStartTimer();
    }, t.prototype._flushAll = function() {
      var e = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(e._finishedSpans.length / e._maxExportBatchSize), a = 0, s = o; a < s; a++)
          i.push(e._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, t.prototype._flushOneBatch = function() {
      var e = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, e._exportTimeoutMillis);
        p.with(Vr(p.active()), function() {
          var o;
          e._finishedSpans.length <= e._maxExportBatchSize ? (o = e._finishedSpans, e._finishedSpans = []) : o = e._finishedSpans.splice(0, e._maxExportBatchSize);
          for (var a = function() {
            return e._exporter.export(o, function(E) {
              var f;
              clearTimeout(i), E.code === ht.SUCCESS ? r() : n((f = E.error) !== null && f !== void 0 ? f : new Error("BatchSpanProcessor: span export failed"));
            });
          }, s = null, u = 0, _ = o.length; u < _; u++) {
            var c = o[u];
            c.resource.asyncAttributesPending && c.resource.waitForAsyncAttributes && (s ?? (s = []), s.push(c.resource.waitForAsyncAttributes()));
          }
          s === null ? a() : Promise.all(s).then(a, function(E) {
            X(E), n(E);
          });
        });
      });
    }, t.prototype._maybeStartTimer = function() {
      var e = this;
      if (!this._isExporting) {
        var r = function() {
          e._isExporting = !0, e._flushOneBatch().finally(function() {
            e._isExporting = !1, e._finishedSpans.length > 0 && (e._clearTimer(), e._maybeStartTimer());
          }).catch(function(n) {
            e._isExporting = !1, X(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis), this._timer, void 0);
      }
    }, t.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, t;
  }()
), o_ = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ao = (
  /** @class */
  function(t) {
    o_(e, t);
    function e(r, n) {
      var i = t.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return e.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document < "u" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          X(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          X(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, e.prototype.onShutdown = function() {
      typeof document < "u" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, e;
  }(i_)
), a_ = 8, s_ = 16, u_ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.generateTraceId = yn(s_), this.generateSpanId = yn(a_);
    }
    return t;
  }()
), ae = Array(32);
function yn(t) {
  return function() {
    for (var r = 0; r < t * 2; r++)
      ae[r] = Math.floor(Math.random() * 16) + 48, ae[r] >= 58 && (ae[r] += 39);
    return String.fromCharCode.apply(null, ae.slice(0, t * 2));
  };
}
var __ = (
  /** @class */
  function() {
    function t(e, r, n) {
      this._tracerProvider = n;
      var i = r_(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new u_(), this.resource = n.resource, this.instrumentationLibrary = e;
    }
    return t.prototype.startSpan = function(e, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = p.active()), r.root && (n = O.deleteSpan(n));
      var s = O.getSpan(n);
      if (Ue(n)) {
        d.debug("Instrumentation suppressed, returning Noop Span");
        var u = O.wrapSpanContext(Si);
        return u;
      }
      var _ = s == null ? void 0 : s.spanContext(), c = this._idGenerator.generateSpanId(), E, f, T;
      !_ || !O.isSpanContextValid(_) ? E = this._idGenerator.generateTraceId() : (E = _.traceId, f = _.traceState, T = _.spanId);
      var l = (i = r.kind) !== null && i !== void 0 ? i : G.INTERNAL, S = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(bt) {
        return {
          context: bt.context,
          attributes: kt(bt.attributes)
        };
      }), R = kt(r.attributes), h = this._sampler.shouldSample(n, E, e, l, R, S);
      f = (a = h.traceState) !== null && a !== void 0 ? a : f;
      var g = h.decision === nt.RECORD_AND_SAMPLED ? K.SAMPLED : K.NONE, C = { traceId: E, spanId: c, traceFlags: g, traceState: f };
      if (h.decision === nt.NOT_RECORD) {
        d.debug("Recording is off, propagating context in a non-recording span");
        var u = O.wrapSpanContext(C);
        return u;
      }
      var z = kt(Object.assign(R, h.attributes)), Ke = new t_(this, n, e, C, l, T, S, r.startTime, void 0, z);
      return Ke;
    }, t.prototype.startActiveSpan = function(e, r, n, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = r : arguments.length === 3 ? (o = r, s = n) : (o = r, a = n, s = i);
        var u = a ?? p.active(), _ = this.startSpan(e, o, u), c = O.setSpan(u, _);
        return p.with(c, s, void 0, _);
      }
    }, t.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, t.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, t.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, t;
  }()
), c_ = "service.name", E_ = "telemetry.sdk.name", f_ = "telemetry.sdk.language", d_ = "telemetry.sdk.version", l_ = c_, gn = E_, Pn = f_, Nn = d_;
function T_() {
  return "unknown_service";
}
var it = function() {
  return it = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, it.apply(this, arguments);
}, p_ = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(c) {
      try {
        _(n.next(c));
      } catch (E) {
        a(E);
      }
    }
    function u(c) {
      try {
        _(n.throw(c));
      } catch (E) {
        a(E);
      }
    }
    function _(c) {
      c.done ? o(c.value) : i(c.value).then(s, u);
    }
    _((n = n.apply(t, e || [])).next());
  });
}, h_ = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(_) {
    return function(c) {
      return u([_, c]);
    };
  }
  function u(_) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = _[0] & 2 ? i.return : _[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, _[1])).done) return o;
      switch (i = 0, o && (_ = [_[0] & 2, o.value]), _[0]) {
        case 0:
        case 1:
          o = _;
          break;
        case 4:
          return r.label++, { value: _[1], done: !1 };
        case 5:
          r.label++, i = _[1], _ = [0];
          continue;
        case 7:
          _ = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (_[0] === 6 || _[0] === 2)) {
            r = 0;
            continue;
          }
          if (_[0] === 3 && (!o || _[1] > o[0] && _[1] < o[3])) {
            r.label = _[1];
            break;
          }
          if (_[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = _;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(_);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      _ = e.call(t, r);
    } catch (c) {
      _ = [6, c], i = 0;
    } finally {
      n = o = 0;
    }
    if (_[0] & 5) throw _[1];
    return { value: _[0] ? _[1] : void 0, done: !0 };
  }
}, v_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Lr = (
  /** @class */
  function() {
    function t(e, r) {
      var n = this, i;
      this._attributes = e, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return d.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return t.empty = function() {
      return t.EMPTY;
    }, t.default = function() {
      var e;
      return new t((e = {}, e[l_] = T_(), e[Pn] = $t[Pn], e[gn] = $t[gn], e[Nn] = $t[Nn], e));
    }, Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var e;
        return this.asyncAttributesPending && d.error("Accessing resource attributes before async attributes settled"), (e = this._attributes) !== null && e !== void 0 ? e : {};
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.waitForAsyncAttributes = function() {
      return p_(this, void 0, void 0, function() {
        return h_(this, function(e) {
          switch (e.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.merge = function(e) {
      var r = this, n;
      if (!e)
        return this;
      var i = it(it({}, this._syncAttributes), (n = e._syncAttributes) !== null && n !== void 0 ? n : e.attributes);
      if (!this._asyncAttributesPromise && !e._asyncAttributesPromise)
        return new t(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        e._asyncAttributesPromise
      ]).then(function(a) {
        var s, u = v_(a, 2), _ = u[0], c = u[1];
        return it(it(it(it({}, r._syncAttributes), _), (s = e._syncAttributes) !== null && s !== void 0 ? s : e.attributes), c);
      });
      return new t(i, o);
    }, t.EMPTY = new t({}), t;
  }()
), se = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, In = (
  /** @class */
  function() {
    function t(e) {
      this._spanProcessors = e;
    }
    return t.prototype.forceFlush = function() {
      var e, r, n = [];
      try {
        for (var i = se(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(s) {
        Promise.all(n).then(function() {
          s();
        }).catch(function(u) {
          X(u || new Error("MultiSpanProcessor: forceFlush failed")), s();
        });
      });
    }, t.prototype.onStart = function(e, r) {
      var n, i;
      try {
        for (var o = se(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          s.onStart(e, r);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, t.prototype.onEnd = function(e) {
      var r, n;
      try {
        for (var i = se(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(e);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.shutdown = function() {
      var e, r, n = [];
      try {
        for (var i = se(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(s, u) {
        Promise.all(n).then(function() {
          s();
        }, u);
      });
    }, t;
  }()
), S_ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.onStart = function(e, r) {
    }, t.prototype.onEnd = function(e) {
    }, t.prototype.shutdown = function() {
      return Promise.resolve();
    }, t.prototype.forceFlush = function() {
      return Promise.resolve();
    }, t;
  }()
), O_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, A_ = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, lt;
(function(t) {
  t[t.resolved = 0] = "resolved", t[t.timeout = 1] = "timeout", t[t.error = 2] = "error", t[t.unresolved = 3] = "unresolved";
})(lt || (lt = {}));
var R_ = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Ji({}, io(), n_(e));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : Lr.empty(), i.mergeResourceWithDefaults && (this.resource = Lr.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = e.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = A_([], O_(e.spanProcessors), !1), this.activeSpanProcessor = new In(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new ao(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new S_();
      }
    }
    return t.prototype.getTracer = function(e, r, n) {
      var i = e + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new __({ name: e, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, t.prototype.addSpanProcessor = function(e) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return d.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(e), this.activeSpanProcessor = new In(this._registeredSpanProcessors);
    }, t.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, t.prototype.register = function(e) {
      e === void 0 && (e = {}), O.setGlobalTracerProvider(this), e.propagator === void 0 && (e.propagator = this._buildPropagatorFromEnv()), e.contextManager && p.setGlobalContextManager(e.contextManager), e.propagator && I.setGlobalPropagator(e.propagator);
    }, t.prototype.forceFlush = function() {
      var e = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + e + " ms")), o = lt.timeout;
          }, e);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== lt.timeout && (o = lt.resolved, i(o));
          }).catch(function(s) {
            clearTimeout(a), o = lt.error, i(s);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(s) {
            return s !== lt.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, t.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, t.prototype._getPropagator = function(e) {
      var r;
      return (r = this.constructor._registeredPropagators.get(e)) === null || r === void 0 ? void 0 : r();
    }, t.prototype._getSpanExporter = function(e) {
      var r;
      return (r = this.constructor._registeredExporters.get(e)) === null || r === void 0 ? void 0 : r();
    }, t.prototype._buildPropagatorFromEnv = function() {
      var e = this, r = Array.from(new Set(yt().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = e._getPropagator(o);
        return a || d.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new ji({
          propagators: i
        });
    }, t.prototype._buildExporterFromEnv = function() {
      var e = yt().OTEL_TRACES_EXPORTER;
      if (!(e === "none" || e === "")) {
        var r = this._getSpanExporter(e);
        return r || d.error('Exporter "' + e + '" requested through environment variable is unavailable.'), r;
      }
    }, t._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Yi();
      }],
      ["baggage", function() {
        return new Ci();
      }]
    ]), t._registeredExporters = /* @__PURE__ */ new Map(), t;
  }()
), m_ = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, L_ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.export = function(e, r) {
      return this._sendSpans(e, r);
    }, t.prototype.shutdown = function() {
      return this._sendSpans([]), this.forceFlush();
    }, t.prototype.forceFlush = function() {
      return Promise.resolve();
    }, t.prototype._exportInfo = function(e) {
      var r;
      return {
        resource: {
          attributes: e.resource.attributes
        },
        instrumentationScope: e.instrumentationLibrary,
        traceId: e.spanContext().traceId,
        parentId: e.parentSpanId,
        traceState: (r = e.spanContext().traceState) === null || r === void 0 ? void 0 : r.serialize(),
        name: e.name,
        id: e.spanContext().spanId,
        kind: e.kind,
        timestamp: vr(e.startTime),
        duration: vr(e.duration),
        attributes: e.attributes,
        status: e.status,
        events: e.events,
        links: e.links
      };
    }, t.prototype._sendSpans = function(e, r) {
      var n, i;
      try {
        for (var o = m_(e), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          console.dir(this._exportInfo(s), { depth: 3 });
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      if (r)
        return r({ code: ht.SUCCESS });
    }, t;
  }()
), y_ = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(c) {
      try {
        _(n.next(c));
      } catch (E) {
        a(E);
      }
    }
    function u(c) {
      try {
        _(n.throw(c));
      } catch (E) {
        a(E);
      }
    }
    function _(c) {
      c.done ? o(c.value) : i(c.value).then(s, u);
    }
    _((n = n.apply(t, e || [])).next());
  });
}, g_ = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(_) {
    return function(c) {
      return u([_, c]);
    };
  }
  function u(_) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = _[0] & 2 ? i.return : _[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, _[1])).done) return o;
      switch (i = 0, o && (_ = [_[0] & 2, o.value]), _[0]) {
        case 0:
        case 1:
          o = _;
          break;
        case 4:
          return r.label++, { value: _[1], done: !1 };
        case 5:
          r.label++, i = _[1], _ = [0];
          continue;
        case 7:
          _ = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (_[0] === 6 || _[0] === 2)) {
            r = 0;
            continue;
          }
          if (_[0] === 3 && (!o || _[1] > o[0] && _[1] < o[3])) {
            r.label = _[1];
            break;
          }
          if (_[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = _;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(_);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      _ = e.call(t, r);
    } catch (c) {
      _ = [6, c], i = 0;
    } finally {
      n = o = 0;
    }
    if (_[0] & 5) throw _[1];
    return { value: _[0] ? _[1] : void 0, done: !0 };
  }
}, P_ = (
  /** @class */
  function() {
    function t(e) {
      this._exporter = e, this._shutdownOnce = new qr(this._shutdown, this), this._unresolvedExports = /* @__PURE__ */ new Set();
    }
    return t.prototype.forceFlush = function() {
      return y_(this, void 0, void 0, function() {
        return g_(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, Promise.all(Array.from(this._unresolvedExports))];
            case 1:
              return e.sent(), this._exporter.forceFlush ? [4, this._exporter.forceFlush()] : [3, 3];
            case 2:
              e.sent(), e.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onStart = function(e, r) {
    }, t.prototype.onEnd = function(e) {
      var r = this, n, i;
      if (!this._shutdownOnce.isCalled && e.spanContext().traceFlags & K.SAMPLED) {
        var o = function() {
          return no._export(r._exporter, [e]).then(function(s) {
            var u;
            s.code !== ht.SUCCESS && X((u = s.error) !== null && u !== void 0 ? u : new Error("SimpleSpanProcessor: span export failed (status " + s + ")"));
          }).catch(function(s) {
            X(s);
          });
        };
        if (e.resource.asyncAttributesPending) {
          var a = (i = (n = e.resource).waitForAsyncAttributes) === null || i === void 0 ? void 0 : i.call(n).then(function() {
            return a != null && r._unresolvedExports.delete(a), o();
          }, function(s) {
            return X(s);
          });
          a != null && this._unresolvedExports.add(a);
        } else
          o();
      }
    }, t.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, t.prototype._shutdown = function() {
      return this._exporter.shutdown();
    }, t;
  }()
), N_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, I_ = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, b_ = (
  /** @class */
  function() {
    function t() {
      this._enabled = !1, this._currentContext = w;
    }
    return t.prototype._bindFunction = function(e, r) {
      e === void 0 && (e = w);
      var n = this, i = function() {
        for (var o = this, a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        return n.with(e, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, t.prototype.active = function() {
      return this._currentContext;
    }, t.prototype.bind = function(e, r) {
      return e === void 0 && (e = this.active()), typeof r == "function" ? this._bindFunction(e, r) : r;
    }, t.prototype.disable = function() {
      return this._currentContext = w, this._enabled = !1, this;
    }, t.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = w, this);
    }, t.prototype.with = function(e, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = e || w;
      try {
        return r.call.apply(r, I_([n], N_(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, t;
  }()
), C_ = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), M_ = (
  /** @class */
  function(t) {
    C_(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return e.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new b_()), r.contextManager && r.contextManager.enable(), t.prototype.register.call(this, r);
    }, e;
  }(R_)
), v;
(function(t) {
  t.CONNECT_END = "connectEnd", t.CONNECT_START = "connectStart", t.DECODED_BODY_SIZE = "decodedBodySize", t.DOM_COMPLETE = "domComplete", t.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", t.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", t.DOM_INTERACTIVE = "domInteractive", t.DOMAIN_LOOKUP_END = "domainLookupEnd", t.DOMAIN_LOOKUP_START = "domainLookupStart", t.ENCODED_BODY_SIZE = "encodedBodySize", t.FETCH_START = "fetchStart", t.LOAD_EVENT_END = "loadEventEnd", t.LOAD_EVENT_START = "loadEventStart", t.NAVIGATION_START = "navigationStart", t.REDIRECT_END = "redirectEnd", t.REDIRECT_START = "redirectStart", t.REQUEST_START = "requestStart", t.RESPONSE_END = "responseEnd", t.RESPONSE_START = "responseStart", t.SECURE_CONNECTION_START = "secureConnectionStart", t.UNLOAD_EVENT_END = "unloadEventEnd", t.UNLOAD_EVENT_START = "unloadEventStart";
})(v || (v = {}));
var w_ = "http.response_content_length", D_ = "http.response_content_length_uncompressed", U_ = w_, B_ = D_;
function ct(t, e) {
  return e in t;
}
function N(t, e, r, n) {
  var i = void 0, o = void 0;
  ct(r, e) && typeof r[e] == "number" && (i = r[e]);
  var a = v.FETCH_START;
  if (ct(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return t.addEvent(e, i), t;
}
function Le(t, e, r) {
  r === void 0 && (r = !1), r || (N(t, v.FETCH_START, e), N(t, v.DOMAIN_LOOKUP_START, e), N(t, v.DOMAIN_LOOKUP_END, e), N(t, v.CONNECT_START, e), ct(e, "name") && e.name.startsWith("https:") && N(t, v.SECURE_CONNECTION_START, e), N(t, v.CONNECT_END, e), N(t, v.REQUEST_START, e), N(t, v.RESPONSE_START, e), N(t, v.RESPONSE_END, e));
  var n = e[v.ENCODED_BODY_SIZE];
  n !== void 0 && t.setAttribute(U_, n);
  var i = e[v.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && t.setAttribute(B_, i);
}
function Jr(t, e) {
  if (t.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = G_(t, e);
  if (e && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return t.parentNode && (n += Jr(t.parentNode, !1)), n += r, n;
}
function x_(t) {
  if (!t.parentNode)
    return 0;
  var e = [t.nodeType];
  t.nodeType === Node.CDATA_SECTION_NODE && e.push(Node.TEXT_NODE);
  var r = Array.from(t.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return e.indexOf(n.nodeType) >= 0 && i === t.localName;
  }), r.length >= 1 ? r.indexOf(t) + 1 : 0;
}
function G_(t, e) {
  var r = t.nodeType, n = x_(t), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = t.getAttribute("id");
    if (e && o)
      return '//*[@id="' + o + '"]';
    i = t.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
var et;
(function(t) {
  t.DOCUMENT_LOAD = "documentLoad", t.DOCUMENT_FETCH = "documentFetch", t.RESOURCE_FETCH = "resourceFetch";
})(et || (et = {}));
var H_ = "0.39.0", k_ = "@opentelemetry/instrumentation-document-load";
// @__NO_SIDE_EFFECTS__
function Xe(t) {
  for (var e = {}, r = t.length, n = 0; n < r; n++) {
    var i = t[n];
    i && (e[String(i).toUpperCase().replace(/[-.]/g, "_")] = i);
  }
  return e;
}
var V_ = "aws.lambda.invoked_arn", X_ = "db.system", $_ = "db.connection_string", j_ = "db.user", F_ = "db.jdbc.driver_classname", K_ = "db.name", Y_ = "db.statement", W_ = "db.operation", z_ = "db.mssql.instance_name", Z_ = "db.cassandra.keyspace", q_ = "db.cassandra.page_size", J_ = "db.cassandra.consistency_level", Q_ = "db.cassandra.table", tc = "db.cassandra.idempotence", ec = "db.cassandra.speculative_execution_count", rc = "db.cassandra.coordinator.id", nc = "db.cassandra.coordinator.dc", ic = "db.hbase.namespace", oc = "db.redis.database_index", ac = "db.mongodb.collection", sc = "db.sql.table", uc = "exception.type", _c = "exception.message", cc = "exception.stacktrace", Ec = "exception.escaped", fc = "faas.trigger", dc = "faas.execution", lc = "faas.document.collection", Tc = "faas.document.operation", pc = "faas.document.time", hc = "faas.document.name", vc = "faas.time", Sc = "faas.cron", Oc = "faas.coldstart", Ac = "faas.invoked_name", Rc = "faas.invoked_provider", mc = "faas.invoked_region", Lc = "net.transport", yc = "net.peer.ip", gc = "net.peer.port", Pc = "net.peer.name", Nc = "net.host.ip", Ic = "net.host.port", bc = "net.host.name", Cc = "net.host.connection.type", Mc = "net.host.connection.subtype", wc = "net.host.carrier.name", Dc = "net.host.carrier.mcc", Uc = "net.host.carrier.mnc", Bc = "net.host.carrier.icc", xc = "peer.service", Gc = "enduser.id", Hc = "enduser.role", kc = "enduser.scope", Vc = "thread.id", Xc = "thread.name", $c = "code.function", jc = "code.namespace", Fc = "code.filepath", Kc = "code.lineno", Yc = "http.method", so = "http.url", Wc = "http.target", zc = "http.host", Zc = "http.scheme", qc = "http.status_code", Jc = "http.flavor", uo = "http.user_agent", Qc = "http.request_content_length", tE = "http.request_content_length_uncompressed", eE = "http.response_content_length", rE = "http.response_content_length_uncompressed", nE = "http.server_name", iE = "http.route", oE = "http.client_ip", aE = "aws.dynamodb.table_names", sE = "aws.dynamodb.consumed_capacity", uE = "aws.dynamodb.item_collection_metrics", _E = "aws.dynamodb.provisioned_read_capacity", cE = "aws.dynamodb.provisioned_write_capacity", EE = "aws.dynamodb.consistent_read", fE = "aws.dynamodb.projection", dE = "aws.dynamodb.limit", lE = "aws.dynamodb.attributes_to_get", TE = "aws.dynamodb.index_name", pE = "aws.dynamodb.select", hE = "aws.dynamodb.global_secondary_indexes", vE = "aws.dynamodb.local_secondary_indexes", SE = "aws.dynamodb.exclusive_start_table", OE = "aws.dynamodb.table_count", AE = "aws.dynamodb.scan_forward", RE = "aws.dynamodb.segment", mE = "aws.dynamodb.total_segments", LE = "aws.dynamodb.count", yE = "aws.dynamodb.scanned_count", gE = "aws.dynamodb.attribute_definitions", PE = "aws.dynamodb.global_secondary_index_updates", NE = "messaging.system", IE = "messaging.destination", bE = "messaging.destination_kind", CE = "messaging.temp_destination", ME = "messaging.protocol", wE = "messaging.protocol_version", DE = "messaging.url", UE = "messaging.message_id", BE = "messaging.conversation_id", xE = "messaging.message_payload_size_bytes", GE = "messaging.message_payload_compressed_size_bytes", HE = "messaging.operation", kE = "messaging.consumer_id", VE = "messaging.rabbitmq.routing_key", XE = "messaging.kafka.message_key", $E = "messaging.kafka.consumer_group", jE = "messaging.kafka.client_id", FE = "messaging.kafka.partition", KE = "messaging.kafka.tombstone", YE = "rpc.system", WE = "rpc.service", zE = "rpc.method", ZE = "rpc.grpc.status_code", qE = "rpc.jsonrpc.version", JE = "rpc.jsonrpc.request_id", QE = "rpc.jsonrpc.error_code", tf = "rpc.jsonrpc.error_message", ef = "message.type", rf = "message.id", nf = "message.compressed_size", of = "message.uncompressed_size", he = so, af = uo, x = /* @__PURE__ */ Xe([
  V_,
  X_,
  $_,
  j_,
  F_,
  K_,
  Y_,
  W_,
  z_,
  Z_,
  q_,
  J_,
  Q_,
  tc,
  ec,
  rc,
  nc,
  ic,
  oc,
  ac,
  sc,
  uc,
  _c,
  cc,
  Ec,
  fc,
  dc,
  lc,
  Tc,
  pc,
  hc,
  vc,
  Sc,
  Oc,
  Ac,
  Rc,
  mc,
  Lc,
  yc,
  gc,
  Pc,
  Nc,
  Ic,
  bc,
  Cc,
  Mc,
  wc,
  Dc,
  Uc,
  Bc,
  xc,
  Gc,
  Hc,
  kc,
  Vc,
  Xc,
  $c,
  jc,
  Fc,
  Kc,
  Yc,
  so,
  Wc,
  zc,
  Zc,
  qc,
  Jc,
  uo,
  Qc,
  tE,
  eE,
  rE,
  nE,
  iE,
  oE,
  aE,
  sE,
  uE,
  _E,
  cE,
  EE,
  fE,
  dE,
  lE,
  TE,
  pE,
  hE,
  vE,
  SE,
  OE,
  AE,
  RE,
  mE,
  LE,
  yE,
  gE,
  PE,
  NE,
  IE,
  bE,
  CE,
  ME,
  wE,
  DE,
  UE,
  BE,
  xE,
  GE,
  HE,
  kE,
  VE,
  XE,
  $E,
  jE,
  FE,
  KE,
  YE,
  WE,
  zE,
  ZE,
  qE,
  JE,
  QE,
  tf,
  ef,
  rf,
  nf,
  of
]), sf = "queue", uf = "topic", bn = /* @__PURE__ */ Xe([
  sf,
  uf
]), _f = "receive", cf = "process", Cn = /* @__PURE__ */ Xe([
  _f,
  cf
]), Ef = "cloud.provider", ff = "cloud.account.id", df = "cloud.region", lf = "cloud.availability_zone", Tf = "cloud.platform", pf = "aws.ecs.container.arn", hf = "aws.ecs.cluster.arn", vf = "aws.ecs.launchtype", Sf = "aws.ecs.task.arn", Of = "aws.ecs.task.family", Af = "aws.ecs.task.revision", Rf = "aws.eks.cluster.arn", mf = "aws.log.group.names", Lf = "aws.log.group.arns", yf = "aws.log.stream.names", gf = "aws.log.stream.arns", Pf = "container.name", Nf = "container.id", If = "container.runtime", bf = "container.image.name", Cf = "container.image.tag", Mf = "deployment.environment", wf = "device.id", Df = "device.model.identifier", Uf = "device.model.name", Bf = "faas.name", xf = "faas.id", Gf = "faas.version", Hf = "faas.instance", kf = "faas.max_memory", Vf = "host.id", Xf = "host.name", $f = "host.type", jf = "host.arch", Ff = "host.image.name", Kf = "host.image.id", Yf = "host.image.version", Wf = "k8s.cluster.name", zf = "k8s.node.name", Zf = "k8s.node.uid", qf = "k8s.namespace.name", Jf = "k8s.pod.uid", Qf = "k8s.pod.name", td = "k8s.container.name", ed = "k8s.replicaset.uid", rd = "k8s.replicaset.name", nd = "k8s.deployment.uid", id = "k8s.deployment.name", od = "k8s.statefulset.uid", ad = "k8s.statefulset.name", sd = "k8s.daemonset.uid", ud = "k8s.daemonset.name", _d = "k8s.job.uid", cd = "k8s.job.name", Ed = "k8s.cronjob.uid", fd = "k8s.cronjob.name", dd = "os.type", ld = "os.description", Td = "os.name", pd = "os.version", hd = "process.pid", vd = "process.executable.name", Sd = "process.executable.path", Od = "process.command", Ad = "process.command_line", Rd = "process.command_args", md = "process.owner", Ld = "process.runtime.name", yd = "process.runtime.version", gd = "process.runtime.description", Pd = "service.name", Nd = "service.namespace", Id = "service.instance.id", bd = "service.version", Cd = "telemetry.sdk.name", Md = "telemetry.sdk.language", wd = "telemetry.sdk.version", Dd = "telemetry.auto.version", Ud = "webengine.name", Bd = "webengine.version", xd = "webengine.description", Mn = /* @__PURE__ */ Xe([
  Ef,
  ff,
  df,
  lf,
  Tf,
  pf,
  hf,
  vf,
  Sf,
  Of,
  Af,
  Rf,
  mf,
  Lf,
  yf,
  gf,
  Pf,
  Nf,
  If,
  bf,
  Cf,
  Mf,
  wf,
  Df,
  Uf,
  Bf,
  xf,
  Gf,
  Hf,
  kf,
  Vf,
  Xf,
  $f,
  jf,
  Ff,
  Kf,
  Yf,
  Wf,
  zf,
  Zf,
  qf,
  Jf,
  Qf,
  td,
  ed,
  rd,
  nd,
  id,
  od,
  ad,
  sd,
  ud,
  _d,
  cd,
  Ed,
  fd,
  dd,
  ld,
  Td,
  pd,
  hd,
  vd,
  Sd,
  Od,
  Ad,
  Rd,
  md,
  Ld,
  yd,
  gd,
  Pd,
  Nd,
  Id,
  bd,
  Cd,
  Md,
  wd,
  Dd,
  Ud,
  Bd,
  xd
]), ye;
(function(t) {
  t.FIRST_PAINT = "firstPaint", t.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ye || (ye = {}));
var Gd = function() {
  var t, e, r = {}, n = (e = (t = $).getEntriesByType) === null || e === void 0 ? void 0 : e.call(t, "navigation")[0];
  if (n) {
    var i = Object.values(v);
    i.forEach(function(s) {
      if (ct(n, s)) {
        var u = n[s];
        typeof u == "number" && (r[s] = u);
      }
    });
  } else {
    var o = $, a = o.timing;
    if (a) {
      var i = Object.values(v);
      i.forEach(function(u) {
        if (ct(a, u)) {
          var _ = a[u];
          typeof _ == "number" && (r[u] = _);
        }
      });
    }
  }
  return r;
}, wn = {
  "first-paint": ye.FIRST_PAINT,
  "first-contentful-paint": ye.FIRST_CONTENTFUL_PAINT
}, Hd = function(t) {
  var e, r, n = (r = (e = $).getEntriesByType) === null || r === void 0 ? void 0 : r.call(e, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    ct(wn, o) && t.addEvent(wn[o], a);
  });
}, kd = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vd = (
  /** @class */
  function(t) {
    kd(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, k_, H_, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, e.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = $).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(s) {
        n._initResourceSpan(s, r);
      });
    }, e.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === jt;
      }), i = Gd(), o = n && n.content || "";
      p.with(I.extract(w, { traceparent: o }), function() {
        var a, s = r._startSpan(et.DOCUMENT_LOAD, v.FETCH_START, i);
        s && (p.with(O.setSpan(p.active(), s), function() {
          var u = r._startSpan(et.DOCUMENT_FETCH, v.FETCH_START, i);
          u && (u.setAttribute(he, location.href), p.with(O.setSpan(p.active(), u), function() {
            var _;
            r._getConfig().ignoreNetworkEvents || Le(u, i), r._addCustomAttributesOnSpan(u, (_ = r._getConfig().applyCustomAttributesOnSpan) === null || _ === void 0 ? void 0 : _.documentFetch), r._endSpan(u, v.RESPONSE_END, i);
          }));
        }), s.setAttribute(he, location.href), s.setAttribute(af, navigator.userAgent), r._addResourcesSpans(s), r._getConfig().ignoreNetworkEvents || (N(s, v.FETCH_START, i), N(s, v.UNLOAD_EVENT_START, i), N(s, v.UNLOAD_EVENT_END, i), N(s, v.DOM_INTERACTIVE, i), N(s, v.DOM_CONTENT_LOADED_EVENT_START, i), N(s, v.DOM_CONTENT_LOADED_EVENT_END, i), N(s, v.DOM_COMPLETE, i), N(s, v.LOAD_EVENT_START, i), N(s, v.LOAD_EVENT_END, i)), r._getConfig().ignorePerformancePaintEvents || Hd(s), r._addCustomAttributesOnSpan(s, (a = r._getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(s, v.LOAD_EVENT_END, i));
      });
    }, e.prototype._endSpan = function(r, n, i) {
      r && (ct(i, n) ? r.end(i[n]) : r.end());
    }, e.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(et.RESOURCE_FETCH, v.FETCH_START, r, n);
      o && (o.setAttribute(he, r.name), this._getConfig().ignoreNetworkEvents || Le(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this._getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, v.RESPONSE_END, r));
    }, e.prototype._startSpan = function(r, n, i, o) {
      if (ct(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? O.setSpan(p.active(), o) : void 0);
        return a;
      }
    }, e.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, e.prototype._getConfig = function() {
      return this._config;
    }, e.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && Oe(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      }, !0);
    }, e.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && Oe(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      }, !0);
    }, e.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, e.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, e;
  }(j)
);
function _o(t, e) {
  if (t && t[1] && t[2]) {
    const r = t[1], n = t[2];
    e.setAttribute("link.traceId", r), e.setAttribute("link.spanId", n);
  }
}
const Xd = new RegExp(`traceparent;desc=['"]00-([0-9a-f]{32})-([0-9a-f]{16})-01['"]`);
function co(t, e) {
  for (let r of t.split(",")) {
    r = r.trim();
    const n = r.match(Xd);
    _o(n, e);
  }
}
const $d = new RegExp("00-([0-9a-f]{32})-([0-9a-f]{16})-01");
function jd(t, e) {
  if (t.serverTiming) {
    for (const r of t.serverTiming)
      if (r.name === "traceparent" && r.description) {
        const n = r.description.match($d);
        _o(n, e);
      }
  }
}
const Fd = ["beacon", "fetch", "xmlhttprequest"];
function Kd(t) {
  document.referrer && document.referrer !== "" && t.setAttribute("document.referrer", document.referrer), window.screen && t.setAttribute("screen.xy", window.screen.width + "x" + window.screen.height);
}
class Yd extends Vd {
  constructor(e = {}) {
    super(e);
    const r = this, n = r._endSpan.bind(this);
    r._endSpan = (i, o, a) => {
      var s;
      const u = i;
      if (i && i.setAttribute("component", this.component), i && u.name !== et.DOCUMENT_LOAD) {
        if (u.name === et.DOCUMENT_FETCH && performance.getEntriesByType) {
          const _ = performance.getEntriesByType("navigation");
          !a.serverTiming && (!((s = _[0]) === null || s === void 0) && s.serverTiming) && (a.serverTiming = _[0].serverTiming), _[0] && typeof _[0].responseStatus == "number" && _[0].responseStatus > 0 && i.setAttribute(x.HTTP_STATUS_CODE, _[0].responseStatus);
        }
        jd(a, i), i.setAttribute(x.HTTP_METHOD, "GET");
      }
      return i && u.name === et.DOCUMENT_LOAD && Kd(i), n(i, o, a);
    }, r._initResourceSpan = (i, o) => {
      var a;
      if (Fd.indexOf(i.initiatorType) !== -1 || Ve(i.name, e.ignoreUrls))
        return;
      const s = r._startSpan(et.RESOURCE_FETCH, v.FETCH_START, i, o);
      s && (s.setAttribute(he, i.name), r.getConfig().ignoreNetworkEvents || (Le(s, i), typeof i.responseStatus == "number" && i.responseStatus > 0 && s.setAttribute(x.HTTP_STATUS_CODE, i.responseStatus)), r._addCustomAttributesOnResourceSpan(s, i, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.resourceFetch), r._endSpan(s, v.RESPONSE_END, i));
    };
  }
}
var Jt = performance, Wd = "http.method", zd = "http.url", Zd = "http.host", qd = "http.scheme", Jd = "http.status_code", Qd = "http.user_agent", tl = "http.response_content_length", el = "http.response_content_length_uncompressed", rl = Wd, nl = zd, il = Zd, ol = qd, al = Jd, sl = Qd, ul = tl, _l = el, cl = 9, El = 6, fl = Math.pow(10, El), yr = Math.pow(10, cl);
function ge(t) {
  var e = t / 1e3, r = Math.trunc(e), n = Math.round(t % 1e3 * fl);
  return [r, n];
}
function Eo() {
  var t = Jt.timeOrigin;
  if (typeof t != "number") {
    var e = Jt;
    t = e.timing && e.timing.fetchStart;
  }
  return t;
}
function gr(t) {
  var e = ge(Eo()), r = ge(typeof t == "number" ? t : Jt.now());
  return ll(e, r);
}
function Ft(t) {
  if (dl(t))
    return t;
  if (typeof t == "number")
    return t < Eo() ? gr(t) : ge(t);
  if (t instanceof Date)
    return ge(t.getTime());
  throw TypeError("Invalid input type");
}
function ut(t) {
  return t[0] * yr + t[1];
}
function dl(t) {
  return Array.isArray(t) && t.length === 2 && typeof t[0] == "number" && typeof t[1] == "number";
}
function ll(t, e) {
  var r = [t[0] + e[0], t[1] + e[1]];
  return r[1] >= yr && (r[1] -= yr, r[0] += 1), r;
}
var Tl = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function fo(t, e) {
  return typeof e == "string" ? t === e : !!t.match(e);
}
function pl(t, e) {
  var r, n;
  if (!e)
    return !1;
  try {
    for (var i = Tl(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (fo(t, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var m;
(function(t) {
  t.CONNECT_END = "connectEnd", t.CONNECT_START = "connectStart", t.DECODED_BODY_SIZE = "decodedBodySize", t.DOM_COMPLETE = "domComplete", t.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", t.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", t.DOM_INTERACTIVE = "domInteractive", t.DOMAIN_LOOKUP_END = "domainLookupEnd", t.DOMAIN_LOOKUP_START = "domainLookupStart", t.ENCODED_BODY_SIZE = "encodedBodySize", t.FETCH_START = "fetchStart", t.LOAD_EVENT_END = "loadEventEnd", t.LOAD_EVENT_START = "loadEventStart", t.NAVIGATION_START = "navigationStart", t.REDIRECT_END = "redirectEnd", t.REDIRECT_START = "redirectStart", t.REQUEST_START = "requestStart", t.RESPONSE_END = "responseEnd", t.RESPONSE_START = "responseStart", t.SECURE_CONNECTION_START = "secureConnectionStart", t.UNLOAD_EVENT_END = "unloadEventEnd", t.UNLOAD_EVENT_START = "unloadEventStart";
})(m || (m = {}));
var er;
function hl() {
  return er || (er = document.createElement("a")), er;
}
function Pr(t, e) {
  return e in t;
}
function Z(t, e, r, n) {
  var i = void 0, o = void 0;
  Pr(r, e) && typeof r[e] == "number" && (i = r[e]);
  var a = m.FETCH_START;
  if (Pr(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return t.addEvent(e, i), t;
}
function Dn(t, e) {
  Z(t, m.FETCH_START, e), Z(t, m.DOMAIN_LOOKUP_START, e), Z(t, m.DOMAIN_LOOKUP_END, e), Z(t, m.CONNECT_START, e), Pr(e, "name") && e.name.startsWith("https:") && Z(t, m.SECURE_CONNECTION_START, e), Z(t, m.CONNECT_END, e), Z(t, m.REQUEST_START, e), Z(t, m.RESPONSE_START, e), Z(t, m.RESPONSE_END, e);
  var r = e[m.ENCODED_BODY_SIZE];
  r !== void 0 && t.setAttribute(ul, r);
  var n = e[m.DECODED_BODY_SIZE];
  n !== void 0 && r !== n && t.setAttribute(_l, n);
}
function vl(t) {
  return t.slice().sort(function(e, r) {
    var n = e[m.FETCH_START], i = r[m.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function lo() {
  return typeof location < "u" ? location.origin : void 0;
}
function Sl(t, e, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = Tt(t);
  t = a.toString();
  var s = Al(t, e, r, n, i);
  if (s.length === 0)
    return {
      mainRequest: void 0
    };
  if (s.length === 1)
    return {
      mainRequest: s[0]
    };
  var u = vl(s);
  if (a.origin !== lo() && u.length > 1) {
    var _ = u[0], c = Ol(u, _[m.RESPONSE_END], r), E = _[m.RESPONSE_END], f = c[m.FETCH_START];
    return f < E && (c = _, _ = void 0), {
      corsPreFlightRequest: _,
      mainRequest: c
    };
  } else
    return {
      mainRequest: s[0]
    };
}
function Ol(t, e, r) {
  for (var n = ut(r), i = ut(Ft(e)), o = t[1], a, s = t.length, u = 1; u < s; u++) {
    var _ = t[u], c = ut(Ft(_[m.FETCH_START])), E = ut(Ft(_[m.RESPONSE_END])), f = n - E;
    c >= i && (!a || f < a) && (a = f, o = _);
  }
  return o;
}
function Al(t, e, r, n, i, o) {
  var a = ut(e), s = ut(r), u = n.filter(function(_) {
    var c = ut(Ft(_[m.FETCH_START])), E = ut(Ft(_[m.RESPONSE_END]));
    return _.initiatorType.toLowerCase() === "xmlhttprequest" && _.name === t && c >= a && E <= s;
  });
  return u.length > 0 && (u = u.filter(function(_) {
    return !i.has(_);
  })), u;
}
function Tt(t) {
  if (typeof URL == "function")
    return new URL(t, typeof document < "u" ? document.baseURI : typeof location < "u" ? location.href : void 0);
  var e = hl();
  return e.href = t, e;
}
function Rl(t, e) {
  var r = e || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = Tt(t);
  return n.origin === lo() ? !0 : r.some(function(i) {
    return fo(t, i);
  });
}
var J;
(function(t) {
  t.METHOD_OPEN = "open", t.METHOD_SEND = "send", t.EVENT_ABORT = "abort", t.EVENT_ERROR = "error", t.EVENT_LOAD = "loaded", t.EVENT_TIMEOUT = "timeout";
})(J || (J = {}));
var Un = "0.52.1", Nr;
(function(t) {
  t.HTTP_STATUS_TEXT = "http.status_text";
})(Nr || (Nr = {}));
var ml = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ll = 300, yl = (
  /** @class */
  function(t) {
    ml(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, "@opentelemetry/instrumentation-xml-http-request", Un, r) || this;
      return n.component = "xml-http-request", n.version = Un, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addHeaders = function(r, n) {
      var i = Tt(n).href;
      if (!Rl(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        I.inject(p.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      I.inject(p.active(), a), Object.keys(a).forEach(function(s) {
        r.setRequestHeader(s, String(a[s]));
      });
    }, e.prototype._addChildSpan = function(r, n) {
      var i = this;
      p.with(O.setSpan(p.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[m.FETCH_START]
        });
        i.getConfig().ignoreNetworkEvents || Dn(o, n), o.end(n[m.RESPONSE_END]);
      });
    }, e.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = Tt(i);
        n.status !== void 0 && r.setAttribute(al, n.status), n.statusText !== void 0 && r.setAttribute(Nr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(il, o.host), r.setAttribute(ol, o.protocol.replace(":", "")), r.setAttribute(sl, navigator.userAgent);
      }
    }, e.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && Oe(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      }, !0);
    }, e.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), s = Tt(n);
          a.forEach(function(u) {
            u.initiatorType === "xmlhttprequest" && u.name === s.href && i.createdResources && i.createdResources.entries.push(u);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Jt.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var s = r.createdResources.entries;
        (!s || !s.length) && (s = Jt.getEntriesByType("resource"));
        var u = Sl(Tt(i).href, o, a, s, this._usedResources);
        if (u.mainRequest) {
          var _ = u.mainRequest;
          this._markResourceAsUsed(_);
          var c = u.corsPreFlightRequest;
          c && (this._addChildSpan(n, c), this._markResourceAsUsed(c)), this.getConfig().ignoreNetworkEvents || Dn(n, _);
        }
      }
    }, e.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, e.prototype._createSpan = function(r, n, i) {
      var o;
      if (pl(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), s = this.tracer.startSpan(a, {
        kind: G.CLIENT,
        attributes: (o = {}, o[rl] = i, o[nl] = Tt(n).toString(), o)
      });
      return s.addEvent(J.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: s,
        spanUrl: n
      }), s;
    }, e.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, e.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = a[0], _ = a[1];
          return i._createSpan(this, _, u), n.apply(this, a);
        };
      };
    }, e.prototype._patchSend = function() {
      var r = this;
      function n(c, E, f, T) {
        var l = E.callbackToRemoveEvents;
        typeof l == "function" && l();
        var S = E.span, R = E.spanUrl, h = E.sendStartTime;
        S && (r._findResourceAndAddNetworkEvents(E, S, R, h, f), S.addEvent(c, T), r._addFinalSpanAttributes(S, E, R), S.end(T), r._tasksCount--), r._clearResources();
      }
      function i(c, E) {
        var f = r._xhrMem.get(E);
        if (f) {
          f.status = E.status, f.statusText = E.statusText, r._xhrMem.delete(E), f.span && r._applyAttributesAfterXHR(f.span, E);
          var T = gr(), l = Date.now();
          setTimeout(function() {
            n(c, f, T, l);
          }, Ll);
        }
      }
      function o() {
        i(J.EVENT_ERROR, this);
      }
      function a() {
        i(J.EVENT_ABORT, this);
      }
      function s() {
        i(J.EVENT_TIMEOUT, this);
      }
      function u() {
        this.status < 299 ? i(J.EVENT_LOAD, this) : i(J.EVENT_ERROR, this);
      }
      function _(c) {
        c.removeEventListener("abort", a), c.removeEventListener("error", o), c.removeEventListener("load", u), c.removeEventListener("timeout", s);
        var E = r._xhrMem.get(c);
        E && (E.callbackToRemoveEvents = void 0);
      }
      return function(c) {
        return function() {
          for (var f = this, T = [], l = 0; l < arguments.length; l++)
            T[l] = arguments[l];
          var S = r._xhrMem.get(this);
          if (!S)
            return c.apply(this, T);
          var R = S.span, h = S.spanUrl;
          return R && h && p.with(O.setSpan(p.active(), R), function() {
            r._tasksCount++, S.sendStartTime = gr(), R.addEvent(J.METHOD_SEND), f.addEventListener("abort", a), f.addEventListener("error", o), f.addEventListener("load", u), f.addEventListener("timeout", s), S.callbackToRemoveEvents = function() {
              _(f), S.createdResources && S.createdResources.observer.disconnect();
            }, r._addHeaders(f, h), r._addResourceObserver(f, h);
          }), c.apply(this, T);
        };
      };
    }, e.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), B(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), B(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, e.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, e;
  }(j)
);
class gl extends yl {
  constructor(e = {}) {
    super(e);
    const r = this._createSpan.bind(this);
    this._createSpan = (i, o, a) => {
      const s = r(i, o, a);
      return s && (i.addEventListener("readystatechange", function() {
        if (i.readyState === i.HEADERS_RECEIVED && i.getAllResponseHeaders().toLowerCase().indexOf("server-timing") !== -1) {
          const _ = i.getResponseHeader("server-timing");
          _ !== null && co(_, s);
        }
      }), s.setAttribute("component", this.moduleName), s.updateName(`HTTP ${a.toUpperCase()}`)), s;
    };
    const n = this._addResourceObserver.bind(this);
    this._addResourceObserver = (i, o) => {
      typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || n(i, o);
    };
  }
}
var rr = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ir = performance, Pl = "http.method", Nl = "http.url", Il = "http.host", bl = "http.scheme", Cl = "http.status_code", Ml = "http.user_agent", wl = "http.response_content_length", Dl = "http.response_content_length_uncompressed", Ul = Pl, Bl = Nl, xl = Il, Gl = bl, Hl = Cl, kl = Ml, Vl = wl, Xl = Dl, $l = 9, jl = 6, Fl = Math.pow(10, jl), br = Math.pow(10, $l);
function Qt(t) {
  var e = t / 1e3, r = Math.trunc(e), n = Math.round(t % 1e3 * Fl);
  return [r, n];
}
function To() {
  var t = Ir.timeOrigin;
  if (typeof t != "number") {
    var e = Ir;
    t = e.timing && e.timing.fetchStart;
  }
  return t;
}
function Cr(t) {
  var e = Qt(To()), r = Qt(typeof t == "number" ? t : Ir.now());
  return Yl(e, r);
}
function Kt(t) {
  if (Kl(t))
    return t;
  if (typeof t == "number")
    return t < To() ? Cr(t) : Qt(t);
  if (t instanceof Date)
    return Qt(t.getTime());
  throw TypeError("Invalid input type");
}
function _t(t) {
  return t[0] * br + t[1];
}
function Kl(t) {
  return Array.isArray(t) && t.length === 2 && typeof t[0] == "number" && typeof t[1] == "number";
}
function Yl(t, e) {
  var r = [t[0] + e[0], t[1] + e[1]];
  return r[1] >= br && (r[1] -= br, r[0] += 1), r;
}
var Wl = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function po(t, e) {
  return typeof e == "string" ? t === e : !!t.match(e);
}
function zl(t, e) {
  var r, n;
  if (!e)
    return !1;
  try {
    for (var i = Wl(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (po(t, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var L;
(function(t) {
  t.CONNECT_END = "connectEnd", t.CONNECT_START = "connectStart", t.DECODED_BODY_SIZE = "decodedBodySize", t.DOM_COMPLETE = "domComplete", t.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", t.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", t.DOM_INTERACTIVE = "domInteractive", t.DOMAIN_LOOKUP_END = "domainLookupEnd", t.DOMAIN_LOOKUP_START = "domainLookupStart", t.ENCODED_BODY_SIZE = "encodedBodySize", t.FETCH_START = "fetchStart", t.LOAD_EVENT_END = "loadEventEnd", t.LOAD_EVENT_START = "loadEventStart", t.NAVIGATION_START = "navigationStart", t.REDIRECT_END = "redirectEnd", t.REDIRECT_START = "redirectStart", t.REQUEST_START = "requestStart", t.RESPONSE_END = "responseEnd", t.RESPONSE_START = "responseStart", t.SECURE_CONNECTION_START = "secureConnectionStart", t.UNLOAD_EVENT_END = "unloadEventEnd", t.UNLOAD_EVENT_START = "unloadEventStart";
})(L || (L = {}));
var nr;
function Zl() {
  return nr || (nr = document.createElement("a")), nr;
}
function Mr(t, e) {
  return e in t;
}
function q(t, e, r, n) {
  var i = void 0, o = void 0;
  Mr(r, e) && typeof r[e] == "number" && (i = r[e]);
  var a = L.FETCH_START;
  if (Mr(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return t.addEvent(e, i), t;
}
function Bn(t, e) {
  q(t, L.FETCH_START, e), q(t, L.DOMAIN_LOOKUP_START, e), q(t, L.DOMAIN_LOOKUP_END, e), q(t, L.CONNECT_START, e), Mr(e, "name") && e.name.startsWith("https:") && q(t, L.SECURE_CONNECTION_START, e), q(t, L.CONNECT_END, e), q(t, L.REQUEST_START, e), q(t, L.RESPONSE_START, e), q(t, L.RESPONSE_END, e);
  var r = e[L.ENCODED_BODY_SIZE];
  r !== void 0 && t.setAttribute(Vl, r);
  var n = e[L.DECODED_BODY_SIZE];
  n !== void 0 && r !== n && t.setAttribute(Xl, n);
}
function ql(t) {
  return t.slice().sort(function(e, r) {
    var n = e[L.FETCH_START], i = r[L.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function ho() {
  return typeof location < "u" ? location.origin : void 0;
}
function Jl(t, e, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = Pe(t);
  t = a.toString();
  var s = tT(t, e, r, n, i, o);
  if (s.length === 0)
    return {
      mainRequest: void 0
    };
  if (s.length === 1)
    return {
      mainRequest: s[0]
    };
  var u = ql(s);
  if (a.origin !== ho() && u.length > 1) {
    var _ = u[0], c = Ql(u, _[L.RESPONSE_END], r), E = _[L.RESPONSE_END], f = c[L.FETCH_START];
    return f < E && (c = _, _ = void 0), {
      corsPreFlightRequest: _,
      mainRequest: c
    };
  } else
    return {
      mainRequest: s[0]
    };
}
function Ql(t, e, r) {
  for (var n = _t(r), i = _t(Kt(e)), o = t[1], a, s = t.length, u = 1; u < s; u++) {
    var _ = t[u], c = _t(Kt(_[L.FETCH_START])), E = _t(Kt(_[L.RESPONSE_END])), f = n - E;
    c >= i && (!a || f < a) && (a = f, o = _);
  }
  return o;
}
function tT(t, e, r, n, i, o) {
  var a = _t(e), s = _t(r), u = n.filter(function(_) {
    var c = _t(Kt(_[L.FETCH_START])), E = _t(Kt(_[L.RESPONSE_END]));
    return _.initiatorType.toLowerCase() === o && _.name === t && c >= a && E <= s;
  });
  return u.length > 0 && (u = u.filter(function(_) {
    return !i.has(_);
  })), u;
}
function Pe(t) {
  if (typeof URL == "function")
    return new URL(t, typeof document < "u" ? document.baseURI : typeof location < "u" ? location.href : void 0);
  var e = Zl();
  return e.href = t, e;
}
function eT(t, e) {
  var r = e || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = Pe(t);
  return n.origin === ho() ? !0 : r.some(function(i) {
    return po(t, i);
  });
}
var Ne;
(function(t) {
  t.COMPONENT = "component", t.HTTP_ERROR_NAME = "http.error_name", t.HTTP_STATUS_TEXT = "http.status_text";
})(Ne || (Ne = {}));
var xn = "0.52.1", rT = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ir, nT = 300, Gn = typeof process == "object" && ((ir = process.release) === null || ir === void 0 ? void 0 : ir.name) === "node", iT = (
  /** @class */
  function(t) {
    rT(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, "@opentelemetry/instrumentation-fetch", xn, r) || this;
      return n.component = "fetch", n.version = xn, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[L.FETCH_START]
      }, O.setSpan(p.active(), r));
      this.getConfig().ignoreNetworkEvents || Bn(i, n), i.end(n[L.RESPONSE_END]);
    }, e.prototype._addFinalSpanAttributes = function(r, n) {
      var i = Pe(n.url);
      r.setAttribute(Hl, n.status), n.statusText != null && r.setAttribute(Ne.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(xl, i.host), r.setAttribute(Gl, i.protocol.replace(":", "")), typeof navigator < "u" && r.setAttribute(kl, navigator.userAgent);
    }, e.prototype._addHeaders = function(r, n) {
      if (!eT(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        I.inject(p.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        I.inject(p.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Headers)
        I.inject(p.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Map)
        I.inject(p.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else {
        var i = {};
        I.inject(p.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), zl(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: G.CLIENT,
        attributes: (i = {}, i[Ne.COMPONENT] = this.moduleName, i[Ul] = o, i[Bl] = r, i)
      });
    }, e.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = Jl(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var s = a.mainRequest;
        this._markResourceAsUsed(s);
        var u = a.corsPreFlightRequest;
        u && (this._addChildSpan(r, u), this._markResourceAsUsed(u)), this.getConfig().ignoreNetworkEvents || Bn(r, s);
      }
    }, e.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, e.prototype._endSpan = function(r, n, i) {
      var o = this, a = Qt(Date.now()), s = Cr();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var u;
        (u = n.observer) === null || u === void 0 || u.disconnect(), o._findResourceAndAddNetworkEvents(r, n, s), o._tasksCount--, o._clearResources(), r.end(a);
      }, nT);
    }, e.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = this, _ = Pe(a[0] instanceof Request ? a[0].url : String(a[0])).href, c = a[0] instanceof Request ? a[0] : a[1] || {}, E = i._createSpan(_, c);
          if (!E)
            return n.apply(this, a);
          var f = i._prepareSpanData(_);
          function T(h, g) {
            i._applyAttributesAfterFetch(h, c, g), i._endSpan(h, f, {
              status: g.status || 0,
              statusText: g.message,
              url: _
            });
          }
          function l(h, g) {
            i._applyAttributesAfterFetch(h, c, g), g.status >= 200 && g.status < 400 ? i._endSpan(h, f, g) : i._endSpan(h, f, {
              status: g.status,
              statusText: g.statusText,
              url: _
            });
          }
          function S(h, g, C) {
            try {
              var z = C.clone(), Ke = C.clone(), bt = z.body;
              if (bt) {
                var ea = bt.getReader(), _n = function() {
                  ea.read().then(function(Ye) {
                    var ra = Ye.done;
                    ra ? l(h, Ke) : _n();
                  }, function(Ye) {
                    T(h, Ye);
                  });
                };
                _n();
              } else
                l(h, C);
            } finally {
              g(C);
            }
          }
          function R(h, g, C) {
            try {
              T(h, C);
            } finally {
              g(C);
            }
          }
          return new Promise(function(h, g) {
            return p.with(O.setSpan(p.active(), E), function() {
              return i._addHeaders(c, _), i._tasksCount++, n.apply(u, c instanceof Request ? [c] : [_, c]).then(S.bind(u, E, h), R.bind(u, E, g));
            });
          });
        };
      };
    }, e.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && Oe(function() {
        return a(r, n, i);
      }, function(s) {
        s && o._diag.error("applyCustomAttributesOnSpan", s);
      }, !0);
    }, e.prototype._prepareSpanData = function(r) {
      var n = Cr(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var s = a.getEntries();
        s.forEach(function(u) {
          u.initiatorType === "fetch" && u.name === r && i.push(u);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, e.prototype.enable = function() {
      if (Gn) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      B(fetch) && (this._unwrap(rr, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(rr, "fetch", this._patchConstructor());
    }, e.prototype.disable = function() {
      Gn || (this._unwrap(rr, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e;
  }(j)
);
class oT extends iT {
  constructor(e = {}) {
    const r = e.applyCustomAttributesOnSpan;
    e.applyCustomAttributesOnSpan = function(i, o, a) {
      if (i.updateName(`HTTP ${(o.method || "GET").toUpperCase()}`), i.setAttribute("component", "fetch"), i && a instanceof Response && a.headers) {
        const s = a.headers.get("Server-Timing");
        s && co(s, i);
      }
      r && r(i, o, a);
    }, super(e);
    const n = this._addHeaders.bind(this);
    this._addHeaders = (i, o) => {
      try {
        i.headers && Array.isArray(i.headers) && (i.headers = new Headers(i.headers));
      } catch (a) {
        d.error("Error fixing headers", a);
      }
      return n(i, o);
    };
  }
  enable() {
    window.fetch && super.enable();
  }
}
var At;
(function(t) {
  t.EVENT_TYPE = "event_type", t.TARGET_ELEMENT = "target_element", t.TARGET_XPATH = "target_xpath", t.HTTP_URL = "http.url";
})(At || (At = {}));
const Hn = "0.34.0", aT = "Navigation:", sT = ["click"];
function uT() {
  return !1;
}
class _T extends j {
  constructor(e) {
    var r;
    super("@opentelemetry/instrumentation-user-interaction", Hn, e), this.moduleName = "user-interaction", this.version = Hn, this._eventsSpanMap = /* @__PURE__ */ new WeakMap(), this._spansData = /* @__PURE__ */ new WeakMap(), this._wrappedListeners = /* @__PURE__ */ new WeakMap(), this._eventNames = new Set((r = e == null ? void 0 : e.eventNames) !== null && r !== void 0 ? r : sT), this._shouldPreventSpanCreation = typeof (e == null ? void 0 : e.shouldPreventSpanCreation) == "function" ? e.shouldPreventSpanCreation : uT;
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const e = this;
    return (r) => function(...i) {
      const o = `${location.pathname}${location.hash}${location.search}`, a = r.apply(this, i), s = `${location.pathname}${location.hash}${location.search}`;
      return o !== s && e._updateInteractionName(s), a;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    B(history.replaceState) && this._unwrap(history, "replaceState"), B(history.pushState) && this._unwrap(history, "pushState"), B(history.back) && this._unwrap(history, "back"), B(history.forward) && this._unwrap(history, "forward"), B(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(e) {
    const r = O.getSpan(p.active());
    r && typeof r.updateName == "function" && r.updateName(`${aT} ${e}`);
  }
  /**
   * implements unpatch function
   */
  disable() {
    this._getPatchableEventTargets().forEach((r) => {
      B(r.addEventListener) && this._unwrap(r, "addEventListener"), B(r.removeEventListener) && this._unwrap(r, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * implements enable function
   */
  enable() {
    this._zonePatched = !1, this._getPatchableEventTargets().forEach((r) => {
      B(r.addEventListener) && (this._unwrap(r, "addEventListener"), this._diag.debug("removing previous patch from method addEventListener")), B(r.removeEventListener) && (this._unwrap(r, "removeEventListener"), this._diag.debug("removing previous patch from method removeEventListener")), this._wrap(r, "addEventListener", this._patchAddEventListener()), this._wrap(r, "removeEventListener", this._patchRemoveEventListener());
    }), this._patchHistoryApi();
  }
  /**
   * returns Zone
   */
  getZoneWithPrototype() {
  }
  init() {
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(e) {
    return this._eventNames.has(e);
  }
  /**
   * Creates a new span
   * @param element
   * @param eventName
   * @param parentSpan
   */
  _createSpan(e, r, n) {
    if (!(e instanceof Element) || !e.getAttribute || e.hasAttribute("disabled") || !this._allowEventName(r))
      return;
    const i = Jr(e, !0);
    try {
      const o = this.tracer.startSpan(r, {
        attributes: {
          [At.EVENT_TYPE]: r,
          [At.TARGET_ELEMENT]: e.tagName,
          [At.TARGET_XPATH]: i,
          [At.HTTP_URL]: window.location.href
        }
      }, n ? O.setSpan(p.active(), n) : void 0);
      return this._shouldPreventSpanCreation(r, e, o) === !0 ? void 0 : (this._spansData.set(o, {
        taskCount: 0
      }), o);
    } catch (o) {
      this._diag.error("failed to start create new user interaction span", o);
    }
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(e, r, n) {
    return typeof e == "function" ? e.apply(r, n) : e.handleEvent(n[0]);
  }
  /**
   * This patches the addEventListener of Element to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const e = this;
    return (r) => function(i, o, a) {
      if (!o)
        return r.call(this, i, o, a);
      const s = a && typeof a == "object" && a.once, u = function(..._) {
        let c;
        const E = _[0], f = E == null ? void 0 : E.target;
        E && (c = e._eventsSpanMap.get(E)), s && e.removePatchedListener(this, i, o);
        const T = e._createSpan(f, i, c);
        return T ? (E && e._eventsSpanMap.set(E, T), p.with(O.setSpan(p.active(), T), () => {
          const l = e._invokeListener(o, this, _);
          return T.end(), l;
        })) : e._invokeListener(o, this, _);
      };
      if (e.addPatchedListener(this, i, o, u))
        return r.call(this, i, u, a);
    };
  }
  /**
   * This patches the removeEventListener of Element to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const e = this;
    return (r) => function(i, o, a) {
      const s = e.removePatchedListener(this, i, o);
      return s ? r.call(this, i, s, a) : r.call(this, i, o, a);
    };
  }
  /**
   * Returns true if we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(e, r, n, i) {
    let o = this._wrappedListeners.get(n);
    o || (o = /* @__PURE__ */ new Map(), this._wrappedListeners.set(n, o));
    let a = o.get(r);
    return a || (a = /* @__PURE__ */ new Map(), o.set(r, a)), a.has(e) ? !1 : (a.set(e, i), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(e, r, n) {
    const i = this._wrappedListeners.get(n);
    if (!i)
      return;
    const o = i.get(r);
    if (!o)
      return;
    const a = o.get(e);
    return a && (o.delete(e), o.size === 0 && (i.delete(r), i.size === 0 && this._wrappedListeners.delete(n))), a;
  }
}
const Qr = {
  // pointer
  click: !0,
  dblclick: !0,
  mousedown: !0,
  mouseup: !0,
  // form
  submit: !0,
  reset: !0,
  change: !0,
  // drap & drop
  dragend: !0,
  drop: !0,
  // media
  ended: !0,
  pause: !0,
  play: !0
}, cT = Object.keys(Qr), kn = "route", Vn = "1";
function ET(t) {
  return t && (typeof t == "function" || typeof t == "object" && typeof t.handleEvent == "function");
}
class fT extends _T {
  constructor(e = {}) {
    if (!e.eventNames) {
      const i = Object.assign({}, Qr, e.events), o = Object.entries(i).filter(([, a]) => a).map(([a]) => a);
      e.eventNames = o;
    }
    super(e), this._routingTracer = O.getTracer(kn, Vn);
    const r = this._createSpan.bind(this);
    this._createSpan = (i, o, a) => {
      i === document && (i = document.documentElement);
      const s = r(i, o, a);
      return s && s.setAttribute("component", this.moduleName), s;
    };
    const n = this._patchAddEventListener.bind(this);
    this._patchAddEventListener = () => {
      const i = n();
      return (o) => {
        const a = i(o);
        return function(s, u, _) {
          return ET(u) ? (_ === null && (_ = void 0), a.call(this, s, u, _)) : o.call(this, s, u, _);
        };
      };
    };
  }
  // FIXME find cleaner way to patch
  _patchHistoryMethod() {
    const e = this;
    return (r) => function(...i) {
      const o = location.href, a = r.apply(this, i), s = location.href;
      return o !== s && e._emitRouteChangeSpan(o), a;
    };
  }
  disable() {
    super.disable(), window.removeEventListener("hashchange", this.__hashChangeHandler);
  }
  enable() {
    this.__hashChangeHandler = (e) => {
      this._emitRouteChangeSpan(e.oldURL);
    }, window.addEventListener("hashchange", this.__hashChangeHandler), super.enable();
  }
  getZoneWithPrototype() {
  }
  setTracerProvider(e) {
    super.setTracerProvider(e), this._routingTracer = e.getTracer(kn, Vn);
  }
  _emitRouteChangeSpan(e) {
    const r = Date.now(), n = this._routingTracer.startSpan("routeChange", { startTime: r });
    n.setAttribute("component", this.moduleName), n.setAttribute("prev.href", e), n.end(r);
  }
}
var V = {};
const dT = /* @__PURE__ */ Oi(Ja), lT = /* @__PURE__ */ Oi(Ku);
var vo = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.SpanKind = void 0, function(e) {
    e.CLIENT = "CLIENT", e.SERVER = "SERVER", e.CONSUMER = "CONSUMER", e.PRODUCER = "PRODUCER";
  }(t.SpanKind || (t.SpanKind = {}));
})(vo);
Object.defineProperty(V, "__esModule", { value: !0 });
V._toZipkinAnnotations = V._toZipkinTags = Ao = V.toZipkinSpan = Oo = V.defaultStatusErrorTagName = So = V.defaultStatusCodeTagName = void 0;
const ot = dT, wr = lT, ue = vo, TT = {
  [ot.SpanKind.CLIENT]: ue.SpanKind.CLIENT,
  [ot.SpanKind.SERVER]: ue.SpanKind.SERVER,
  [ot.SpanKind.CONSUMER]: ue.SpanKind.CONSUMER,
  [ot.SpanKind.PRODUCER]: ue.SpanKind.PRODUCER,
  // When absent, the span is local.
  [ot.SpanKind.INTERNAL]: void 0
};
var So = V.defaultStatusCodeTagName = "otel.status_code", Oo = V.defaultStatusErrorTagName = "error";
function pT(t, e, r, n) {
  return {
    traceId: t.spanContext().traceId,
    parentId: t.parentSpanId,
    name: t.name,
    id: t.spanContext().spanId,
    kind: TT[t.kind],
    timestamp: (0, wr.hrTimeToMicroseconds)(t.startTime),
    duration: Math.round((0, wr.hrTimeToMicroseconds)(t.duration)),
    localEndpoint: { serviceName: e },
    tags: Ro(t, r, n),
    annotations: t.events.length ? mo(t.events) : void 0
  };
}
var Ao = V.toZipkinSpan = pT;
function Ro({ attributes: t, resource: e, status: r, droppedAttributesCount: n, droppedEventsCount: i, droppedLinksCount: o }, a, s) {
  const u = {};
  for (const _ of Object.keys(t))
    u[_] = String(t[_]);
  return r.code !== ot.SpanStatusCode.UNSET && (u[a] = String(ot.SpanStatusCode[r.code])), r.code === ot.SpanStatusCode.ERROR && r.message && (u[s] = r.message), n && (u["otel.dropped_attributes_count"] = String(n)), i && (u["otel.dropped_events_count"] = String(i)), o && (u["otel.dropped_links_count"] = String(o)), Object.keys(e.attributes).forEach((_) => u[_] = String(e.attributes[_])), u;
}
V._toZipkinTags = Ro;
function mo(t) {
  return t.map((e) => ({
    timestamp: Math.round((0, wr.hrTimeToMicroseconds)(e.time)),
    value: e.name
  }));
}
V._toZipkinAnnotations = mo;
function tn(t) {
  return "x".repeat(t / 4).replace(/x/g, function() {
    return (Math.random() * 16 | 0).toString(16);
  });
}
function te(t, e) {
  return t.length > e ? t.substring(0, e) : t;
}
function Xn(t, e, r) {
  return t === !1 ? t : t === void 0 && r ? !1 : Object.assign({}, e, t);
}
function M(t) {
  return typeof t == "function";
}
function hT() {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}
function P(t, e, r) {
  const n = t[e];
  y.wrap(t, e, r);
  const i = t[e];
  i.toString = n.toString.bind(n);
}
function $n(t) {
  for (; t.__original && t.__original !== t; )
    t = t.__original;
  return t;
}
function vT(t, e) {
  if (window[t])
    return e(window[t]), () => {
    };
  const r = window[t];
  let n = !1;
  return Object.defineProperty(window, t, {
    get() {
      return r;
    },
    set(i) {
      delete window[t], n = !0, window[t] = i, e(i);
    },
    configurable: !0,
    enumerable: !1
  }), () => {
    n || window[t] !== r || (delete window[t], r !== void 0 && (window[t] = r));
  };
}
function Lo(t) {
  return t;
}
function yo(t, e, r) {
  const n = new XMLHttpRequest();
  n.open("POST", t), Object.entries(Object.assign(Object.assign({}, {
    Accept: "application/json",
    "Content-Type": "application/json"
  }), r)).forEach(([o, a]) => {
    n.setRequestHeader(o, a);
  }), n.send(e);
}
function go(t, e, r) {
  const n = r ? new Blob([e], r) : e;
  navigator.sendBeacon(t, n);
}
const jn = 4096, ST = "browser";
class OT {
  constructor({ url: e, onAttributesSerializing: r = Lo, xhrSender: n = yo, beaconSender: i = go }) {
    this.beaconUrl = e, this._onAttributesSerializing = r, this._xhrSender = n, this._beaconSender = i;
  }
  export(e, r) {
    const n = e.map((o) => this._mapToZipkinSpan(o)), i = JSON.stringify(n);
    document.hidden && this._beaconSender && i.length <= 64e3 ? this._beaconSender(this.beaconUrl, i) : this._xhrSender(this.beaconUrl, i, {
      Accept: "*/*",
      "Content-Type": "text/plain;charset=UTF-8"
    }), r({ code: ht.SUCCESS });
  }
  shutdown() {
    return Promise.resolve();
  }
  _mapToZipkinSpan(e) {
    const r = this._preTranslateSpan(e), n = Ao(r, ST, So, Oo);
    return this._postTranslateSpan(n);
  }
  _postTranslateSpan(e) {
    delete e.localEndpoint, e.name = te(e.name, jn);
    for (const [n, i] of Object.entries(e.tags))
      e.tags[n] = te(i.toString(), jn);
    const r = performance.timeOrigin * 1e3;
    return e.tags["http.url"] && !e.tags["http.url"].startsWith(location.origin) && e.timestamp > r && e.annotations && (e.annotations = e.annotations.filter(({ timestamp: n }) => (
      // Chrome has increased precision on timeOrigin but otel may round it
      // Due to multiple roundings and truncs it can be less than timeOrigin
      n > r
    ))), e;
  }
  _preTranslateSpan(e) {
    return {
      // todo: once typescript is implemented, conform to ReadableSpan
      // note: some properties in Span are not enumerable, and as a result cannot be spread or Object.assign'ed
      name: e.name,
      kind: e.kind,
      spanContext: e.spanContext.bind(e),
      parentSpanId: e.parentSpanId,
      startTime: e.startTime,
      endTime: e.endTime,
      status: e.status,
      links: e.links,
      events: e.events,
      duration: e.duration,
      ended: e.ended,
      instrumentationLibrary: e.instrumentationLibrary,
      resource: e.resource,
      attributes: this._onAttributesSerializing ? this._onAttributesSerializing(e.attributes, e) : e.attributes,
      droppedAttributesCount: e.droppedAttributesCount,
      droppedEventsCount: e.droppedEventsCount,
      droppedLinksCount: e.droppedLinksCount
    };
  }
}
const AT = 4096, Fn = 1024, RT = /([\w]+:\/\/[^\s/]+\/[^\s?:#]+)/g;
function xt(t) {
  return t && t.trim() !== "" && !t.startsWith("[object") && t !== "error";
}
function Kn(t) {
  if (t === void 0)
    return "(undefined)";
  if (t.toString)
    return t.toString();
  try {
    return Object.prototype.toString.call(t);
  } catch {
    return "(unknown)";
  }
}
function mT(t) {
  const e = {}, r = t.match(RT);
  return r && r.forEach((n) => {
    const i = n.split(/:(?=\d+$)/)[0], o = window.sourceMapIds;
    o && o[i] && !e[i] && (e[i] = o[i]);
  }), JSON.stringify(e);
}
function Yn(t, e) {
  if (e && e.stack && xt(e.stack)) {
    t.setAttribute("error.stack", te(e.stack.toString(), AT));
    const r = mT(e.stack);
    r && t.setAttribute("error.source_map_ids", r);
  }
}
const en = "errors", LT = "1";
class Po extends j {
  constructor(e) {
    super(en, LT, e), this._consoleErrorHandler = (r) => (...n) => (this.report("console.error", n), r.apply(this, n)), this._documentErrorListener = (r) => {
      this.report("eventListener.error", r);
    }, this._errorListener = (r) => {
      this.report("onerror", r);
    }, this._unhandledRejectionListener = (r) => {
      this.report("unhandledrejection", r.reason);
    };
  }
  disable() {
    y.unwrap(console, "error"), window.removeEventListener("unhandledrejection", this._unhandledRejectionListener), window.removeEventListener("error", this._errorListener), document.documentElement.removeEventListener("error", this._documentErrorListener, { capture: !0 });
  }
  enable() {
    y.wrap(console, "error", this._consoleErrorHandler), window.addEventListener("unhandledrejection", this._unhandledRejectionListener), window.addEventListener("error", this._errorListener), document.documentElement.addEventListener("error", this._documentErrorListener, { capture: !0 });
  }
  init() {
  }
  report(e, r) {
    if (!(Array.isArray(r) && r.length === 0))
      if (r instanceof Array && r.length === 1 && (r = r[0]), r instanceof Error)
        this.reportError(e, r);
      else if (r instanceof ErrorEvent)
        this.reportErrorEvent(e, r);
      else if (r instanceof Event)
        this.reportEvent(e, r);
      else if (typeof r == "string")
        this.reportString(e, r);
      else if (r instanceof Array) {
        const n = r.find((i) => i instanceof Error);
        this.reportString(e, r.map((i) => Kn(i)).join(" "), n);
      } else
        this.reportString(e, Kn(r));
  }
  reportError(e, r) {
    const n = r.message || r.toString();
    if (!xt(n) && !r.stack)
      return;
    const i = Date.now(), o = this.tracer.startSpan(e, { startTime: i });
    o.setAttribute("component", "error"), o.setAttribute("error", !0), o.setAttribute("error.object", xt(r.name) ? r.name : r.constructor && r.constructor.name ? r.constructor.name : "Error"), o.setAttribute("error.message", te(n, Fn)), Yn(o, r), o.end(i);
  }
  reportErrorEvent(e, r) {
    r.error ? this.report(e, r.error) : r.message && this.report(e, r.message);
  }
  reportEvent(e, r) {
    if (!r.target && !xt(r.type))
      return;
    const n = Date.now(), i = this.tracer.startSpan(e, { startTime: n });
    i.setAttribute("component", "error"), i.setAttribute("error.type", r.type), r.target && (i.setAttribute("target_element", r.target.tagName), i.setAttribute("target_xpath", Jr(r.target, !0)), i.setAttribute("target_src", r.target.src)), i.end(n);
  }
  reportString(e, r, n) {
    if (!xt(r))
      return;
    const i = Date.now(), o = this.tracer.startSpan(e, { startTime: i });
    o.setAttribute("component", "error"), o.setAttribute("error", !0), o.setAttribute("error.object", "String"), o.setAttribute("error.message", te(r, Fn)), n && Yn(o, n), o.end(i);
  }
}
const yT = 32, gT = 4 * 60 * 60, PT = gT * 1e3, rn = 15 * 60 * 1e3, NT = rn / 1e3, IT = "_splunk_rum_sid", bT = (t) => typeof t == "object" && t !== null && "id" in t && typeof t.id == "string" && t.id.length === yT && "startTime" in t && typeof t.startTime == "number", No = (t) => {
  const e = Date.now();
  return t.startTime > e || e > t.startTime + PT;
}, CT = (t) => t.expiresAt === void 0 ? !1 : Date.now() > t.expiresAt;
function Io(t, e) {
  let r = 0, n = null, i = null, o;
  const a = (...f) => {
    r = performance.now();
    try {
      t(...f);
    } finally {
      o = void 0;
    }
  }, s = () => {
    i && (document.removeEventListener("visibilitychange", i, { capture: !0 }), i = null);
  }, u = (...f) => {
    i && document.removeEventListener("visibilitychange", i, { capture: !0 }), i = () => {
      if (document.visibilityState === "hidden")
        try {
          a(...f);
        } finally {
          _(), s();
        }
    }, document.addEventListener("visibilitychange", i, { capture: !0 });
  }, _ = () => {
    n !== null && (clearTimeout(n), n = null);
  }, c = (...f) => {
    n !== null && _(), n = setTimeout(() => {
      try {
        a(...f);
      } finally {
        s(), _();
      }
    }, e - (performance.now() - r));
  }, E = (...f) => {
    o = f, s(), _(), performance.now() - r >= e || r === 0 ? a(...f) : (c(...f), u(...f));
  };
  return E.flush = () => {
    try {
      o && a(...o);
    } finally {
      s(), _();
    }
  }, E;
}
const MT = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
class wT {
  constructor(e) {
    this.key = e, this.throttledSetRaw = Io((r) => {
      document.cookie = r;
    }, 1e3);
  }
  flush() {
    this.throttledSetRaw.flush();
  }
  get({ forceDiskRead: e = !1 } = {}) {
    return this.cachedValue === null || e ? (this.cachedValue = this._deserialize(this._getRaw(this.key)), this.cachedValue) : this.cachedValue;
  }
  remove(e) {
    const r = e ? `domain=${e};` : "", n = `${this.key}=;${r}path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    this.throttledSetRaw(n), this.flush();
  }
  set(e, r) {
    this.cachedValue = e, this.throttledSetRaw(this._serialize(e, r));
  }
  _deserialize(e) {
    if (!e)
      return;
    let r;
    try {
      r = JSON.parse(e);
    } catch {
      return;
    }
    return r;
  }
  _getRaw(e) {
    const r = document.cookie.split(";");
    for (let n = 0; n < r.length; n++) {
      const i = r[n].trim();
      if (i.indexOf(e + "=") === 0)
        return decodeURIComponent(i.substring((e + "=").length, i.length));
    }
  }
  _serialize(e, r) {
    const n = encodeURIComponent(JSON.stringify(e)), i = r ? `domain=${r};` : "";
    let o = `${this.key}=${n};path=/;${i};max-age=${NT}`;
    return hT() ? ["localhost", "127.0.0.1"].includes(window.location.hostname) && MT ? o += ";SameSite=None" : o += ";SameSite=None; Secure" : o += ";SameSite=Strict", o;
  }
}
class DT {
  constructor(e) {
    this.key = e, this.throttledSetRaw = Io((r) => {
      BT(this.key, r);
    }, 1e3);
  }
  flush() {
    this.throttledSetRaw.flush();
  }
  get({ forceDiskRead: e = !1 } = {}) {
    return (this.cachedValue === void 0 || e) && (this.cachedValue = JSON.parse(UT(this.key))), this.cachedValue;
  }
  remove() {
    xT(this.key), this.cachedValue = void 0, this.flush();
  }
  set(e) {
    this.cachedValue = e, this.throttledSetRaw(JSON.stringify(e));
  }
}
const UT = (t) => {
  let e = null;
  try {
    e = window.localStorage.getItem(t);
  } catch {
  }
  return e;
}, BT = (t, e) => {
  try {
    return console.log("localStorage setting", t, e), window.localStorage.setItem(t, e), !0;
  } catch {
    return !1;
  }
}, xT = (t) => {
  try {
    window.localStorage.removeItem(t);
  } catch {
  }
}, GT = (t) => {
  try {
    return window.sessionStorage.getItem(t);
  } catch {
    return;
  }
}, HT = (t, e) => {
  try {
    return window.sessionStorage.setItem(t, e), !0;
  } catch {
    return !1;
  }
};
function kT(t) {
  if (t.type == "localStorage")
    return new DT(t.key);
  if (t.type == "cookie")
    return new wT(t.key);
  throw new Error("Unknown store type");
}
const D = "0.20.1", Ie = Symbol.for("opentelemetry.js.api.1"), pt = "splunk.rum", at = `${pt}.version`;
function VT(t, e = !1) {
  if (!globalThis[Ie])
    return d.error("SplunkRum: Tried to access global before otel setup"), !1;
  const r = globalThis[Ie];
  return r[at] || (r[at] = D), r[at] !== D ? (d.error(`SplunkRum: Global: Multiple versions detected (${D} already registered)`), !1) : !e && r[pt] ? (d.error(`SplunkRum: Attempted duplicate registration of otel API ${pt}`), !1) : (r[pt] = t, !0);
}
function XT() {
  const t = globalThis[Ie];
  return t ? (t[at] && t[at] !== D && d.warn(`SplunkRum version in OTel API ref (${t[at]}) didn't match our version (${D}).`), delete t[pt], delete t[at], !0) : (d.warn(`OTel API ref was missing while trying to unregister ${pt} or ${at}`), !1);
}
function $T() {
  var t;
  return (t = globalThis[Ie]) === null || t === void 0 ? void 0 : t[pt];
}
let Yt = !1, bo, Wt;
function Wn() {
  Yt = !0;
}
function jT(t) {
  return window.__splunkRumIntegrationTestSessionId ? window.__splunkRumIntegrationTestSessionId : t || tn(128);
}
function Co(t) {
  return {
    expiresAt: Date.now() + rn,
    id: jT(t),
    startTime: Date.now()
  };
}
let Q = null;
function FT() {
  return Q;
}
function KT() {
  const t = FT();
  if (t)
    return t;
  throw new Error("Session store was accessed but not initialized.");
}
function Mo() {
  let t = ee({ forceDiskRead: !1 });
  return t || (t = ne({ forceStore: !0, inactive: !0 })), t;
}
function ee({ forceDiskRead: t = !1 }) {
  const e = KT().get({ forceDiskRead: t });
  if (bT(e) && !(No(e) || CT(e)))
    return e;
}
function ne({ forceStore: t, hadActivity: e, inactive: r = void 0 }) {
  let n = ee({ forceDiskRead: t }), i = !1;
  return n || (n = ee({ forceDiskRead: !0 }), n || (n = Co(), Yt = !0, i = !0)), n.inactive !== r && (n.inactive = r, i = !0), Wt == null || Wt.emit("session-changed", { sessionId: n.id }), (Yt || e) && (n.expiresAt = Date.now() + rn, No(n) || (Q.set(n, bo), i && Q.flush())), Yt = !1, n;
}
function wo() {
  return typeof window < "u" && window.SplunkRumNative && window.SplunkRumNative.getNativeSessionId;
}
class YT {
  forceFlush() {
    return Promise.resolve();
  }
  onEnd() {
  }
  onStart() {
    ne({
      forceStore: !1,
      hadActivity: !0
    });
  }
  shutdown() {
    return Promise.resolve();
  }
}
const zn = ["click", "scroll", "mousedown", "keydown", "touchend", "visibilitychange"];
function WT(t, e, r, n, i = !1) {
  if (wo()) {
    const a = window.SplunkRumNative.getNativeSessionId(), s = Co(a);
    return Q = {
      get: () => s,
      flush: () => {
      },
      set: () => {
        throw new Error("Cannot override native RUM session ID.");
      },
      remove: () => {
        throw new Error("Cannot clear native RUM session ID.");
      }
    }, {
      deinit: () => {
      },
      clearSession: () => {
      },
      flush: () => {
      }
    };
  }
  Q = kT({
    type: t,
    key: IT
  }), n && (bo = n), Yt = !0, Wt = r, zn.forEach((a) => document.addEventListener(a, Wn, { capture: !0, passive: !0 })), i && e.addSpanProcessor(new YT()), ne({ forceStore: !0 });
  const o = $T();
  return o && (o.store = Q), {
    deinit: () => {
      zn.forEach((a) => document.removeEventListener(a, Wn)), Wt = void 0;
    },
    clearSession: () => {
      Q.remove(), Q.flush();
    },
    flush: () => {
      Q.flush();
    }
  };
}
function zT() {
  if (wo())
    return window.SplunkRumNative.getNativeSessionId();
  const t = ee({ forceDiskRead: !0 });
  if (!(!t || t.inactive))
    return t.id;
}
function Zn(t) {
  return t.byteLength || t.size || t.length || void 0;
}
class ZT extends j {
  constructor(e) {
    super("splunk-websocket", D, e), this.listener2ws2patched = /* @__PURE__ */ new WeakMap(), this._config = e;
  }
  disable() {
    y.unwrap(window, "WebSocket");
  }
  enable() {
    const e = this;
    function r() {
      class n extends WebSocket {
        constructor(o, a) {
          if (Ve(o, e._config.ignoreUrls)) {
            super(o, a);
            return;
          }
          const s = e.tracer.startSpan("connect", {
            kind: G.CLIENT,
            attributes: {
              component: "websocket"
            }
          });
          o && s.setAttribute("http.url", o), a && (typeof a == "string" ? s.setAttribute("protocols", a) : s.setAttribute("protocols", JSON.stringify(a)));
          try {
            super(o, a);
          } catch (u) {
            throw e.endSpanExceptionally(s, u), u;
          }
          this.addEventListener("open", function() {
            s.end();
          }), this.addEventListener("error", function(u) {
            s.isRecording() ? e.endSpanExceptionally(s, new Error(u.error || u.message || "Could not connect.")) : e.startSpan(this, "error", G.CLIENT).end();
          }), e.patchSend(this), e.patchEventListener(this);
        }
      }
      return n;
    }
    y.wrap(window, "WebSocket", r);
  }
  init() {
  }
  // Returns true iff we should use the patched callback; false if it's already been patched
  addPatchedListener(e, r, n) {
    let i = this.listener2ws2patched.get(r);
    return i || (i = /* @__PURE__ */ new Map(), this.listener2ws2patched.set(r, i)), i.has(e) ? !1 : (i.set(e, n), !0);
  }
  endSpanExceptionally(e, r) {
    e.setAttribute("error", !0), e.setAttribute("error.message", r.message), e.setAttribute("error.object", r.name ? r.name : r.constructor && r.constructor.name ? r.constructor.name : "Error"), e.end();
  }
  // FIXME need to share logic better with userinteraction instrumentation
  patchEventListener(e) {
    const r = this, n = e.addEventListener.bind(e);
    e.addEventListener = function(a, s, u) {
      if (a !== "message") {
        n(a, s, u);
        return;
      }
      const _ = typeof u == "boolean" || u == null ? void 0 : u.once, c = function(...f) {
        const T = this, l = f;
        _ && r.removePatchedListener(e, s);
        const S = r.startSpan(e, "onmessage", G.CONSUMER);
        l && l[0] && l[0].data && S.setAttribute("http.response_content_length", Zn(l[0].data)), p.with(O.setSpan(p.active(), S), () => {
          let R;
          return typeof s == "function" ? R = s.apply(T, l) : R = s.handleEvent(f[0]), S.end(), R;
        });
      };
      r.addPatchedListener(e, s, c) && n.apply(e, [a, c, u]);
    };
    const i = e.removeEventListener;
    e.removeEventListener = function(o, a, s) {
      if (o !== "message")
        return i.call(e, o, a, s);
      const u = r.removePatchedListener(e, a);
      return u ? i.call(e, o, u, s) : i.call(e, o, a, s);
    };
  }
  patchSend(e) {
    const r = this, n = e.send;
    e.send = function(...o) {
      const a = r.startSpan(e, "send", G.PRODUCER), s = o.length > 0 ? Zn(o[0]) : void 0;
      a.setAttribute("http.request_content_length", s);
      let u;
      try {
        u = n.apply(e, o);
      } catch (_) {
        throw r.endSpanExceptionally(a, _), _;
      }
      return u === !1 && r.endSpanExceptionally(a, new Error("Failed to send frame.")), a.end(), u;
    };
  }
  // Returns patched listener or undefined
  removePatchedListener(e, r) {
    const n = this.listener2ws2patched.get(r);
    if (!n)
      return;
    const i = n.get(e);
    return i && (n.delete(e), n.size === 0 && this.listener2ws2patched.delete(e)), i;
  }
  startSpan(e, r, n) {
    const i = this.tracer.startSpan(r, { kind: n });
    return i.setAttribute("component", "websocket"), i.setAttribute("protocol", e.protocol), i.setAttribute("http.url", e.url), i;
  }
}
var st, zt, Do, be, Dr, Uo = -1, Nt = function(t) {
  addEventListener("pageshow", function(e) {
    e.persisted && (Uo = e.timeStamp, t(e));
  }, !0);
}, Bo = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, nn = function() {
  var t = Bo();
  return t && t.activationStart || 0;
}, Y = function(t, e) {
  var r = Bo(), n = "navigate";
  return Uo >= 0 ? n = "back-forward-cache" : r && (document.prerendering || nn() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: t, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, It = function(t, e, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          e(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: t, buffered: !0 }, r || {})), n;
    }
  } catch {
  }
}, W = function(t, e, r, n) {
  var i, o;
  return function(a) {
    e.value >= 0 && (a || n) && ((o = e.value - (i || 0)) || i === void 0) && (i = e.value, e.delta = o, e.rating = function(s, u) {
      return s > u[1] ? "poor" : s > u[0] ? "needs-improvement" : "good";
    }(e.value, r), t(e));
  };
}, on = function(t) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return t();
    });
  });
}, $e = function(t) {
  var e = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || t(r);
  };
  addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
}, an = function(t) {
  var e = !1;
  return function(r) {
    e || (t(r), e = !0);
  };
}, Rt = -1, qn = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Ce = function(t) {
  document.visibilityState === "hidden" && Rt > -1 && (Rt = t.type === "visibilitychange" ? t.timeStamp : 0, qT());
}, Jn = function() {
  addEventListener("visibilitychange", Ce, !0), addEventListener("prerenderingchange", Ce, !0);
}, qT = function() {
  removeEventListener("visibilitychange", Ce, !0), removeEventListener("prerenderingchange", Ce, !0);
}, sn = function() {
  return Rt < 0 && (Rt = qn(), Jn(), Nt(function() {
    setTimeout(function() {
      Rt = qn(), Jn();
    }, 0);
  })), { get firstHiddenTime() {
    return Rt;
  } };
}, je = function(t) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return t();
  }, !0) : t();
}, Qn = [1800, 3e3], JT = function(t, e) {
  e = e || {}, je(function() {
    var r, n = sn(), i = Y("FCP"), o = It("paint", function(a) {
      a.forEach(function(s) {
        s.name === "first-contentful-paint" && (o.disconnect(), s.startTime < n.firstHiddenTime && (i.value = Math.max(s.startTime - nn(), 0), i.entries.push(s), r(!0)));
      });
    });
    o && (r = W(t, i, Qn, e.reportAllChanges), Nt(function(a) {
      i = Y("FCP"), r = W(t, i, Qn, e.reportAllChanges), on(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, ti = [0.1, 0.25], QT = function(t, e) {
  e = e || {}, JT(an(function() {
    var r, n = Y("CLS", 0), i = 0, o = [], a = function(u) {
      u.forEach(function(_) {
        if (!_.hadRecentInput) {
          var c = o[0], E = o[o.length - 1];
          i && _.startTime - E.startTime < 1e3 && _.startTime - c.startTime < 5e3 ? (i += _.value, o.push(_)) : (i = _.value, o = [_]);
        }
      }), i > n.value && (n.value = i, n.entries = o, r());
    }, s = It("layout-shift", a);
    s && (r = W(t, n, ti, e.reportAllChanges), $e(function() {
      a(s.takeRecords()), r(!0);
    }), Nt(function() {
      i = 0, n = Y("CLS", 0), r = W(t, n, ti, e.reportAllChanges), on(function() {
        return r();
      });
    }), setTimeout(r, 0));
  }));
}, Gt = { passive: !0, capture: !0 }, tp = /* @__PURE__ */ new Date(), ei = function(t, e) {
  st || (st = e, zt = t, Do = /* @__PURE__ */ new Date(), Go(removeEventListener), xo());
}, xo = function() {
  if (zt >= 0 && zt < Do - tp) {
    var t = { entryType: "first-input", name: st.type, target: st.target, cancelable: st.cancelable, startTime: st.timeStamp, processingStart: st.timeStamp + zt };
    be.forEach(function(e) {
      e(t);
    }), be = [];
  }
}, ep = function(t) {
  if (t.cancelable) {
    var e = (t.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - t.timeStamp;
    t.type == "pointerdown" ? function(r, n) {
      var i = function() {
        ei(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, Gt), removeEventListener("pointercancel", o, Gt);
      };
      addEventListener("pointerup", i, Gt), addEventListener("pointercancel", o, Gt);
    }(e, t) : ei(e, t);
  }
}, Go = function(t) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(e) {
    return t(e, ep, Gt);
  });
}, ri = [100, 300], rp = function(t, e) {
  e = e || {}, je(function() {
    var r, n = sn(), i = Y("FID"), o = function(u) {
      u.startTime < n.firstHiddenTime && (i.value = u.processingStart - u.startTime, i.entries.push(u), r(!0));
    }, a = function(u) {
      u.forEach(o);
    }, s = It("first-input", a);
    r = W(t, i, ri, e.reportAllChanges), s && $e(an(function() {
      a(s.takeRecords()), s.disconnect();
    })), s && Nt(function() {
      var u;
      i = Y("FID"), r = W(t, i, ri, e.reportAllChanges), be = [], zt = -1, st = null, Go(addEventListener), u = o, be.push(u), xo();
    });
  });
}, Ho = 0, or = 1 / 0, _e = 0, np = function(t) {
  t.forEach(function(e) {
    e.interactionId && (or = Math.min(or, e.interactionId), _e = Math.max(_e, e.interactionId), Ho = _e ? (_e - or) / 7 + 1 : 0);
  });
}, ko = function() {
  return Dr ? Ho : performance.interactionCount || 0;
}, ip = function() {
  "interactionCount" in performance || Dr || (Dr = It("event", np, { type: "event", buffered: !0, durationThreshold: 0 }));
}, ni = [200, 500], Vo = 0, ii = function() {
  return ko() - Vo;
}, F = [], ar = {}, oi = function(t) {
  var e = F[F.length - 1], r = ar[t.interactionId];
  if (r || F.length < 10 || t.duration > e.latency) {
    if (r) r.entries.push(t), r.latency = Math.max(r.latency, t.duration);
    else {
      var n = { id: t.interactionId, latency: t.duration, entries: [t] };
      ar[n.id] = n, F.push(n);
    }
    F.sort(function(i, o) {
      return o.latency - i.latency;
    }), F.splice(10).forEach(function(i) {
      delete ar[i.id];
    });
  }
}, op = function(t, e) {
  e = e || {}, je(function() {
    var r;
    ip();
    var n, i = Y("INP"), o = function(s) {
      s.forEach(function(c) {
        c.interactionId && oi(c), c.entryType === "first-input" && !F.some(function(E) {
          return E.entries.some(function(f) {
            return c.duration === f.duration && c.startTime === f.startTime;
          });
        }) && oi(c);
      });
      var u, _ = (u = Math.min(F.length - 1, Math.floor(ii() / 50)), F[u]);
      _ && _.latency !== i.value && (i.value = _.latency, i.entries = _.entries, n());
    }, a = It("event", o, { durationThreshold: (r = e.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = W(t, i, ni, e.reportAllChanges), a && ("PerformanceEventTiming" in window && "interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), $e(function() {
      o(a.takeRecords()), i.value < 0 && ii() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Nt(function() {
      F = [], Vo = ko(), i = Y("INP"), n = W(t, i, ni, e.reportAllChanges);
    }));
  });
}, ai = [2500, 4e3], sr = {}, ap = function(t, e) {
  e = e || {}, je(function() {
    var r, n = sn(), i = Y("LCP"), o = function(u) {
      var _ = u[u.length - 1];
      _ && _.startTime < n.firstHiddenTime && (i.value = Math.max(_.startTime - nn(), 0), i.entries = [_], r());
    }, a = It("largest-contentful-paint", o);
    if (a) {
      r = W(t, i, ai, e.reportAllChanges);
      var s = an(function() {
        sr[i.id] || (o(a.takeRecords()), a.disconnect(), sr[i.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach(function(u) {
        addEventListener(u, function() {
          return setTimeout(s, 0);
        }, !0);
      }), $e(s), Nt(function(u) {
        i = Y("LCP"), r = W(t, i, ai, e.reportAllChanges), on(function() {
          i.value = performance.now() - u.timeStamp, sr[i.id] = !0, r(!0);
        });
      });
    }
  });
};
const si = {};
function ce(t, e, r) {
  if (si[e])
    return;
  si[e] = !0;
  const n = r.value, i = Date.now(), o = t.startSpan("webvitals", { startTime: i });
  o.setAttribute(e, n), o.end(i);
}
function sp(t, e = {}) {
  const r = t.getTracer("webvitals");
  e.fid !== !1 && rp((n) => {
    ce(r, "fid", n);
  }, typeof e.fid == "object" ? e.fid : void 0), e.cls !== !1 && QT((n) => {
    ce(r, "cls", n);
  }, typeof e.cls == "object" ? e.cls : void 0), e.lcp !== !1 && ap((n) => {
    ce(r, "lcp", n);
  }, typeof e.lcp == "object" ? e.lcp : void 0), e.inp !== !1 && op((n) => {
    ce(r, "inp", n);
  }, typeof e.inp == "object" ? e.inp : void 0);
}
const ur = "longtask", ui = "splunk-longtask";
class Xo extends j {
  constructor(e = {}, r) {
    super(ui, D, Object.assign({}, e)), this.initOptions = r;
  }
  disable() {
    this.isSupported() && this._longtaskObserver.disconnect();
  }
  enable() {
    this.isSupported() && (this._longtaskObserver = new PerformanceObserver((e) => {
      e.getEntries().forEach((r) => this._createSpanFromEntry(r));
    }), this._longtaskObserver.observe({ type: ur, buffered: !0 }));
  }
  init() {
  }
  _createSpanFromEntry(e) {
    const r = ee({ forceDiskRead: !1 }), n = !r || r.inactive;
    if (this.initOptions._experimental_longtaskNoStartSession && n)
      return;
    const i = this.tracer.startSpan(ur, {
      startTime: e.startTime
    });
    i.setAttribute("component", ui), i.setAttribute("longtask.name", e.name), i.setAttribute("longtask.entry_type", e.entryType), i.setAttribute("longtask.duration", e.duration);
    const o = e.attribution;
    Array.isArray(o) && o.forEach((a, s) => {
      const u = a > 1 ? `longtask.attribution[${s}]` : "longtask.attribution";
      i.setAttribute(`${u}.name`, a.name), i.setAttribute(`${u}.entry_type`, a.entryType), i.setAttribute(`${u}.start_time`, a.startTime), i.setAttribute(`${u}.duration`, a.duration), i.setAttribute(`${u}.container_type`, a.containerType), i.setAttribute(`${u}.container_src`, a.containerSrc), i.setAttribute(`${u}.container_id`, a.containerId), i.setAttribute(`${u}.container_name`, a.containerName);
    }), i.end(e.startTime + e.duration);
  }
  // TODO: change name, _isSupported is taken by parent
  isSupported() {
    return (window.PerformanceObserver && PerformanceObserver.supportedEntryTypes || []).includes(ur);
  }
}
const up = "splunk-visibility";
class _p extends j {
  constructor(e = {}) {
    super(up, D, Object.assign({}, e)), this.unloading = !1;
  }
  disable() {
    window.removeEventListener("beforeunload", this.unloadListener), window.removeEventListener("visibilitychange", this.visibilityListener);
  }
  enable() {
    document.hidden && this._createSpan(document.hidden), this.unloadListener = () => {
      this.unloading = !0;
    }, this.visibilityListener = () => {
      this.unloading || this._createSpan(document.hidden);
    }, window.addEventListener("beforeunload", this.unloadListener), window.addEventListener("visibilitychange", this.visibilityListener);
  }
  init() {
  }
  _createSpan(e) {
    const r = Date.now(), n = this.tracer.startSpan("visibility", { startTime: r });
    n.setAttribute("hidden", e), n.end(r);
  }
}
const cp = "splunk-connectivity";
class Ep extends j {
  constructor(e = {}) {
    super(cp, D, Object.assign({}, e)), this.offlineStart = navigator.onLine ? null : Date.now();
  }
  disable() {
    window.removeEventListener("offline", this.offlineListener), window.removeEventListener("online", this.onlineListener);
  }
  enable() {
    this.offlineListener = () => {
      this.offlineStart = Date.now();
    }, this.onlineListener = () => {
      this.offlineStart && (this._createSpan(!1, this.offlineStart), this._createSpan(!0, Date.now()));
    }, window.addEventListener("offline", this.offlineListener), window.addEventListener("online", this.onlineListener);
  }
  init() {
  }
  _createSpan(e, r) {
    const n = this.tracer.startSpan("connectivity", { startTime: r });
    n.setAttribute("online", e), n.end(r);
  }
}
const _i = "splunk-post-doc-load-resource", fp = ["img", "script"], dp = (t) => t instanceof HTMLScriptElement || t instanceof HTMLImageElement;
class $o extends j {
  constructor(e = {}) {
    const r = Object.assign({}, { allowedInitiatorTypes: fp }, e);
    super(_i, D, r), this.config = r, this.urlToContextMap = {};
  }
  disable() {
    this.performanceObserver && this.performanceObserver.disconnect(), this.headMutationObserver && this.headMutationObserver.disconnect();
  }
  enable() {
    window.PerformanceObserver && window.addEventListener("load", () => {
      this._startPerformanceObserver();
    }), window.MutationObserver && this._startHeadMutationObserver();
  }
  init() {
  }
  onBeforeContextChange() {
    this._processHeadMutationObserverRecords(this.headMutationObserver.takeRecords());
  }
  // TODO: discuss TS built-in types
  _createSpan(e) {
    if (Ve(e.name, this.config.ignoreUrls))
      return;
    const r = new URL(e.name, location.origin), n = this.tracer.startSpan(
      //TODO use @opentelemetry/instrumentation-document-load AttributeNames.RESOURCE_FETCH ?,
      // AttributeNames not exported currently
      "resourceFetch",
      {
        startTime: e.fetchStart
      },
      this.urlToContextMap[r.toString()]
    );
    n.setAttribute("component", _i), n.setAttribute(x.HTTP_URL, e.name), n.setAttribute(x.HTTP_METHOD, "GET"), Le(n, e);
    const i = e.responseEnd;
    i && i > 0 ? n.end(i) : n.end();
  }
  // for each added node that corresponds to a resource load, create an entry in `this.urlToContextMap`
  // that associates its fully-qualified URL to the tracing context at the time that it was added
  _processHeadMutationObserverRecords(e) {
    p.active() !== w && e.flatMap((r) => Array.from(r.addedNodes || [])).filter(dp).forEach((r) => {
      const n = r.getAttribute("src");
      if (!n)
        return;
      const i = new URL(n, location.origin);
      this.urlToContextMap[i.toString()] = p.active();
    });
  }
  _startHeadMutationObserver() {
    this.headMutationObserver = new MutationObserver(this._processHeadMutationObserverRecords.bind(this)), this.headMutationObserver.observe(document.head, { childList: !0 });
  }
  _startPerformanceObserver() {
    this.performanceObserver = new PerformanceObserver((e) => {
      window.document.readyState === "complete" && e.getEntries().forEach((r) => {
        this.config.allowedInitiatorTypes.includes(r.initiatorType) && this._createSpan(r);
      });
    }), this.performanceObserver.observe({ entryTypes: ["resource"] });
  }
}
class lp extends M_ {
  shutdown() {
    return new Promise((e) => {
      I.disable(), p.disable(), O.disable(), e();
    }).then(() => super.shutdown());
  }
}
class Tp {
  constructor() {
    this.events = {};
  }
  addEventListener(e, r) {
    this.events[e] || (this.events[e] = []), this.events[e].push(r);
  }
  emit(e, r) {
    const n = this.events[e];
    n && n.forEach((i) => {
      Promise.resolve({ payload: r }).then(i);
    });
  }
  removeEventListener(e, r) {
    if (!this.events[e])
      return;
    const n = this.events[e].indexOf(r);
    n >= 0 && this.events[e].splice(n, 1);
  }
}
const H = "__splunk_context";
class pp {
  constructor(e = {}) {
    this._config = e, this._currentContext = w, this._contextResumingListeners = /* @__PURE__ */ new WeakMap(), this._enabled = !1, this._hashChangeContext = null, this._messagePorts = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Returns the active context
   */
  active() {
    return this._currentContext;
  }
  /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */
  bind(e, r) {
    return M(r) ? this._bindFunction(r, e) : r;
  }
  /**
   * Disable the context manager (clears the current context)
   */
  disable() {
    return this._enabled ? (this._config.async && (this._unpatchTimeouts(), this._unpatchPromise(), this._unpatchMutationObserver(), this._unpatchEvents(), this._unpatchMessageChannel()), this._currentContext = w, this._enabled = !1, this) : this;
  }
  /**
   * Enables the context manager and creates a default(root) context
   */
  enable() {
    return this._enabled ? this : (this._config.async && (this._patchTimeouts(), this._patchPromise(), this._patchMutationObserver(), this._patchEvents(), this._patchMessageChannel()), this._enabled = !0, this._currentContext = w, this);
  }
  /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */
  with(e, r, n, ...i) {
    var o, a, s, u;
    try {
      (a = (o = this._config).onBeforeContextStart) === null || a === void 0 || a.call(o);
    } catch {
    }
    const _ = this._currentContext;
    this._currentContext = e || w;
    const c = location.hash;
    try {
      const E = r.call(n, ...i);
      return (u = (s = this._config).onBeforeContextEnd) === null || u === void 0 || u.call(s), E;
    } finally {
      this._currentContext = _, c !== location.hash && (this._hashChangeContext = e, $n(setTimeout)(() => {
        this._hashChangeContext === e && (this._hashChangeContext = null);
      }, 33));
    }
  }
  /**
   *
   * @param target Function to be executed within the context
   * @param context
   */
  _bindFunction(e, r = w) {
    const n = this, i = function(...o) {
      return n.with(r, () => e.apply(this, o));
    };
    return Object.defineProperty(i, "length", {
      enumerable: !1,
      configurable: !0,
      writable: !1,
      value: e.length
    }), i;
  }
  _getListenersMap(e, r) {
    this._contextResumingListeners.has(e) || this._contextResumingListeners.set(e, /* @__PURE__ */ new Map());
    const n = this._contextResumingListeners.get(e);
    return n.has(r) || n.set(r, /* @__PURE__ */ new WeakMap()), n.get(r);
  }
  _getWrappedEventListener(e, r) {
    const n = this;
    return function(...i) {
      const o = r();
      return o && n._enabled ? n.with(o, e, this, ...i) : e.apply(this, i);
    };
  }
  _patchEvents() {
    const e = this;
    P(XMLHttpRequest.prototype, "addEventListener", (n) => function(...i) {
      if (M(i[1])) {
        const o = e._getListenersMap(this, i[0]);
        let a = o.get(i[1]);
        a || (a = e.bind(e.active(), i[1]), o.set(i[1], a)), i[1] = a;
      }
      return n.apply(this, i);
    }), P(XMLHttpRequest.prototype, "removeEventListener", (n) => function(...i) {
      if (M(i[1])) {
        const a = e._getListenersMap(this, i[0]).get(i[1]);
        a && (i[1] = a);
      }
      return n.apply(this, i);
    }), ["onabort", "onerror", "onload", "onloadend", "onloadstart", "onprogress", "ontimeout"].forEach((n) => {
      const i = Object.getOwnPropertyDescriptor(XMLHttpRequestEventTarget.prototype, n);
      i && (P(i, "get", (o) => function() {
        const a = o.call(this);
        return M(a) && a._orig ? a._orig : a;
      }), P(i, "set", (o) => function(a) {
        if (M(a)) {
          const s = a, u = e.bind(e.active(), a);
          u._orig = s, a = u;
        }
        return o.call(this, a);
      }), Object.defineProperty(XMLHttpRequestEventTarget.prototype, n, i));
    }), P(Window.prototype, "addEventListener", (n) => function(...i) {
      if (i[0] === "hashchange" && M(i[1])) {
        const o = e._getListenersMap(this, i[0]);
        let a = o.get(i[1]);
        a || (a = e._getWrappedEventListener(i[1], () => e._hashChangeContext), o.set(i[1], a)), i[1] = a;
      }
      return n.apply(this, i);
    });
    const r = Object.getOwnPropertyDescriptor(window, "onhashchange");
    P(r, "get", (n) => function() {
      const i = n.call(this);
      return M(i) && i._orig ? i._orig : i;
    }), P(r, "set", (n) => function(i) {
      if (M(i)) {
        const o = e._getWrappedEventListener(i, () => e._hashChangeContext);
        o._orig = i, i = o;
      }
      return n.call(this, i);
    }), Object.defineProperty(window, "onhashchange", r);
  }
  _patchMessageChannel() {
    const e = this;
    P(window, "MessageChannel", (n) => class extends n {
      constructor(...o) {
        super(...o), e._messagePorts.set(this.port1, this.port2), e._messagePorts.set(this.port2, this.port1), Object.defineProperty(this.port1, H, {
          value: null,
          writable: !0,
          enumerable: !1
        }), Object.defineProperty(this.port2, H, {
          value: null,
          writable: !0,
          enumerable: !1
        });
      }
    }), P(MessagePort.prototype, "postMessage", (n) => function(...i) {
      const o = e.active();
      if (!e._messagePorts.has(this) || !o)
        return n.apply(this, i);
      const a = e._messagePorts.get(this);
      a[H] = o;
      const s = n.apply(this, i);
      return $n(setTimeout)(() => {
        a[H] === o && (a[H] = null);
      }, 100), s;
    }), P(MessagePort.prototype, "addEventListener", (n) => function(...i) {
      if (i[0] === "message" && M(i[1])) {
        const o = e._getListenersMap(this, i[0]);
        let a = o.get(i[1]);
        a || (a = e._getWrappedEventListener(i[1], () => this[H]), o.set(i[1], a)), i[1] = a;
      }
      return n.apply(this, i);
    }), P(MessagePort.prototype, "removeEventListener", (n) => function(...i) {
      if (i[0] === "message" && M(i[1])) {
        const a = e._getListenersMap(this, i[0]).get(i[1]);
        a && (i[1] = a);
      }
      return n.apply(this, i);
    });
    const r = Object.getOwnPropertyDescriptor(MessagePort.prototype, "onmessage");
    P(r, "get", (n) => function() {
      const i = n.call(this);
      return M(i) && i._orig ? i._orig : i;
    }), P(r, "set", (n) => function(i) {
      if (M(i)) {
        const o = e._getWrappedEventListener(i, () => this[H]);
        o._orig = i, i = o;
      }
      return n.call(this, i);
    }), Object.defineProperty(MessagePort.prototype, "onmessage", r);
  }
  _patchMutationObserver() {
    const e = this;
    P(window, "MutationObserver", (r) => class extends r {
      constructor(...i) {
        if (M(i[0])) {
          const o = i[0];
          i[0] = function(...a) {
            return this[H] && e._enabled ? e.with(this[H], o, this, ...a) : o.apply(this, a);
          };
        }
        super(...i), Object.defineProperty(this, H, {
          value: null,
          writable: !0,
          enumerable: !1
        });
      }
      observe(...i) {
        if (i[0] && i[0] instanceof Text && !i[0].parentNode && i[1] && i[1].characterData) {
          const o = this, a = i[0], s = Object.getOwnPropertyDescriptor(CharacterData.prototype, "data");
          Object.defineProperty(a, "data", Object.assign(Object.assign({}, s), { enumerable: !1, set: function(...u) {
            const _ = e.active();
            return _ && (o[H] = _), s.set.apply(this, u);
          } }));
        }
        return super.observe(...i);
      }
    });
  }
  _patchPromise() {
    if (!window.Promise)
      return;
    const e = this;
    P(Promise.prototype, "then", (r) => function(...n) {
      return e.bindActiveToArgument(n, 0), e.bindActiveToArgument(n, 1), r.apply(this, n);
    }), P(Promise.prototype, "catch", (r) => function(...n) {
      return e.bindActiveToArgument(n, 0), r.apply(this, n);
    }), P(Promise.prototype, "finally", (r) => function(...n) {
      return e.bindActiveToArgument(n, 0), r.apply(this, n);
    });
  }
  _patchTimeouts() {
    const e = this;
    P(window, "setTimeout", (r) => (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore expects __promisify__ for some reason
      function(...n) {
        return (!n[1] || n[1] <= 34) && e.bindActiveToArgument(n, 0), r.apply(this, n);
      }
    )), window.setImmediate && P(window, "setImmediate", (r) => (
      // @ts-expect-error expects __promisify__
      function(...n) {
        return e.bindActiveToArgument(n, 0), r.apply(this, n);
      }
    )), window.requestAnimationFrame && P(window, "requestAnimationFrame", (r) => function(...n) {
      return e.bindActiveToArgument(n, 0), r.apply(this, n);
    });
  }
  _unpatchEvents() {
    y.unwrap(XMLHttpRequest.prototype, "addEventListener"), y.unwrap(XMLHttpRequest.prototype, "removeEventListener");
  }
  _unpatchMessageChannel() {
    y.unwrap(window, "MessageChannel"), y.unwrap(MessagePort.prototype, "postMessage"), y.unwrap(MessagePort.prototype, "addEventListener"), y.unwrap(MessagePort.prototype, "removeEventListener");
    const e = Object.getOwnPropertyDescriptor(MessagePort.prototype, "onmessage");
    y.unwrap(e, "get"), y.unwrap(e, "set"), Object.defineProperty(MessagePort.prototype, "onmessage", e);
  }
  _unpatchMutationObserver() {
    y.unwrap(window, "MutationObserver");
  }
  _unpatchPromise() {
    window.Promise && (y.unwrap(Promise.prototype, "then"), y.unwrap(Promise.prototype, "catch"), y.unwrap(Promise.prototype, "finally"));
  }
  _unpatchTimeouts() {
    y.unwrap(window, "setTimeout"), window.setImmediate && y.unwrap(window, "setImmediate");
  }
  /**
   * Bind current zone to function given in arguments
   *
   * @param args Arguments array
   * @param index Argument index to patch
   */
  bindActiveToArgument(e, r) {
    M(e[r]) && (e[r] = this.bind(this.active(), e[r]));
  }
}
const hp = "Synthetics-RunId";
function vp() {
  return window.syntheticsRunId;
}
class Sp {
  constructor(e) {
    this._globalAttributes = e ?? {};
  }
  forceFlush() {
    return Promise.resolve();
  }
  getGlobalAttributes() {
    return this._globalAttributes;
  }
  onEnd() {
  }
  onStart(e) {
    const r = ne({ forceStore: !1, inactive: !1 });
    e.setAttribute("location.href", location.href), e.setAttributes(this._globalAttributes), e.setAttribute("splunk.rumSessionId", r.id), e.setAttribute("browser.instance.visibility_state", document.visibilityState);
  }
  setGlobalAttributes(e) {
    if (e)
      Object.assign(this._globalAttributes, e);
    else
      for (const r of Object.keys(this._globalAttributes))
        delete this._globalAttributes[r];
  }
  shutdown() {
    return Promise.resolve();
  }
}
class Op {
  constructor({ ratio: e = 1, sampled: r = new rt(), notSampled: n = new Pt() } = {}) {
    this.ratio = this._normalize(e), this.upperBound = Math.floor(this.ratio * 4294967295), this.sampled = r, this.notSampled = n;
  }
  shouldSample(e, r, n, i, o, a) {
    const s = Mo().id;
    return this.currentSessionId !== s && (this.currentSessionSampled = this._accumulate(s) < this.upperBound, this.currentSessionId = s), (this.currentSessionSampled ? this.sampled : this.notSampled).shouldSample(e, r, n, i, o, a);
  }
  toString() {
    return `SessionBased{ratio=${this.ratio}, sampled=${this.sampled.toString()}, notSampled=${this.notSampled.toString()}}`;
  }
  _accumulate(e) {
    let r = 0;
    for (let n = 0; n < e.length / 8; n++) {
      const i = n * 8, o = parseInt(e.slice(i, i + 8), 16);
      r = (r ^ o) >>> 0;
    }
    return r;
  }
  _normalize(e) {
    return typeof e != "number" || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
  }
}
const Ap = "splunk-socket.io-client", Ee = {
  SOCKET_IO_ROOMS: "messaging.socket.io.rooms",
  SOCKET_IO_NAMESPACE: "messaging.socket.io.namespace",
  SOCKET_IO_EVENT_NAME: "messaging.socket.io.event_name"
};
function Rp(t) {
  return typeof t == "function" && typeof t.Socket == "function";
}
const ci = ["connect", "connect_error", "disconnect", "disconnecting", "newListener", "removeListener"];
class mp extends j {
  constructor(e = {}) {
    super(Ap, D, Object.assign({ target: "io" }, e)), this.listeners = /* @__PURE__ */ new WeakMap();
  }
  disable() {
    this._onDisable && (this._onDisable(), this._onDisable = void 0);
  }
  enable() {
    const e = this.getConfig();
    e.target && (typeof e.target == "string" ? this._onDisable = vT(e.target, (r) => this.patchSocketIo(r)) : this.patchSocketIo(e.target));
  }
  getConfig() {
    return this._config;
  }
  init() {
  }
  patchSocketIo(e) {
    if (!Rp(e)) {
      this._diag.debug("Doesn't seem like socket.io-client", e);
      return;
    }
    const r = this;
    this._wrap(e.Socket.prototype, "emit", (n) => function(i, ...o) {
      const a = r.tracer.startSpan(`${i} send`, {
        kind: G.PRODUCER,
        attributes: {
          [x.MESSAGING_SYSTEM]: "socket.io",
          [x.MESSAGING_DESTINATION]: this.nsp,
          [x.MESSAGING_DESTINATION_KIND]: bn.TOPIC,
          [Ee.SOCKET_IO_NAMESPACE]: this.nsp,
          [Ee.SOCKET_IO_EVENT_NAME]: i
        }
      });
      try {
        return p.with(O.setSpan(p.active(), a), () => n.apply(this, [i, ...o]));
      } catch (s) {
        let u;
        throw s instanceof Error && (a.recordException(s), u = s.message), a.setStatus({ code: Zt.ERROR, message: u }), s;
      } finally {
        a.end();
      }
    }), this._wrap(e.Socket.prototype, "on", (n) => function(i, o) {
      if (ci.includes(i) || typeof o != "function")
        return n.call(this, i, o);
      let a;
      return r.listeners.has(o) ? a = r.listeners.get(o) : (a = function(...s) {
        const u = r.tracer.startSpan(`${i} ${Cn.RECEIVE}`, {
          kind: G.CONSUMER,
          attributes: {
            [x.MESSAGING_SYSTEM]: "socket.io",
            [x.MESSAGING_DESTINATION]: this.nsp,
            [x.MESSAGING_DESTINATION_KIND]: bn.TOPIC,
            [x.MESSAGING_OPERATION]: Cn.RECEIVE,
            [Ee.SOCKET_IO_NAMESPACE]: this.nsp,
            [Ee.SOCKET_IO_EVENT_NAME]: i
          }
        });
        try {
          o.apply(this, s);
        } catch (_) {
          throw _ instanceof Error && u.recordException(_), _;
        } finally {
          u.end();
        }
      }, r.listeners.set(o, a)), n.call(this, i, a);
    }), e.Socket.prototype.addEventListener = e.Socket.prototype.on, this._wrap(e.Socket.prototype, "off", (n) => (
      // all of the remove are implemented as one function
      // https://github.com/socketio/emitter/blob/cd703fe28e5bf85ecf137b0e6422e2608c0eefbf/index.js#L81
      function(i, o) {
        return !i || ci.includes(i) || typeof o != "function" ? n.call(this, i, o) : r.listeners.has(o) ? n.call(this, i, r.listeners.get(o)) : n.call(this, i, o);
      }
    )), e.Socket.prototype.removeListener = e.Socket.prototype.off, e.Socket.prototype.removeEventListener = e.Socket.prototype.off, e.Socket.prototype.removeAllListeners = e.Socket.prototype.off, this._onDisable = () => {
      this._unwrap(e.Socket.prototype, "emit"), this._unwrap(e.Socket.prototype, "on"), e.Socket.prototype.addEventListener = e.Socket.prototype.on, this._unwrap(e.Socket.prototype, "off"), e.Socket.prototype.removeListener = e.Socket.prototype.off, e.Socket.prototype.removeEventListener = e.Socket.prototype.off, e.Socket.prototype.removeAllListeners = e.Socket.prototype.off;
    };
  }
}
var Lp = "=", Ei = ";", yp = ",";
function gp(t) {
  var e = t.split(Ei);
  if (!(e.length <= 0)) {
    var r = e.shift();
    if (r) {
      var n = r.indexOf(Lp);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return e.length > 0 && (a = Be(e.join(Ei))), { key: i, value: o, metadata: a };
      }
    }
  }
}
function Pp(t) {
  return typeof t != "string" || t.length === 0 ? {} : t.split(yp).map(function(e) {
    return gp(e);
  }).filter(function(e) {
    return e !== void 0 && e.value.length > 0;
  }).reduce(function(e, r) {
    return e[r.key] = r.value, e;
  }, {});
}
var Ur;
(function(t) {
  t.AlwaysOff = "always_off", t.AlwaysOn = "always_on", t.ParentBasedAlwaysOff = "parentbased_always_off", t.ParentBasedAlwaysOn = "parentbased_always_on", t.ParentBasedTraceIdRatio = "parentbased_traceidratio", t.TraceIdRatio = "traceidratio";
})(Ur || (Ur = {}));
var Np = ",", Ip = ["OTEL_SDK_DISABLED"];
function bp(t) {
  return Ip.indexOf(t) > -1;
}
var Cp = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Mp(t) {
  return Cp.indexOf(t) > -1;
}
var wp = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS"
];
function Dp(t) {
  return wp.indexOf(t) > -1;
}
var _r = 1 / 0, cr = 128, Up = 128, Bp = 128, jo = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: A.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: _r,
  OTEL_ATTRIBUTE_COUNT_LIMIT: cr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: _r,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: cr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: _r,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: cr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Up,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Bp,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Ur.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function xp(t, e, r) {
  if (!(typeof r[t] > "u")) {
    var n = String(r[t]);
    e[t] = n.toLowerCase() === "true";
  }
}
function Gp(t, e, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[t] < "u") {
    var o = Number(r[t]);
    isNaN(o) || (o < n ? e[t] = n : o > i ? e[t] = i : e[t] = o);
  }
}
function Hp(t, e, r, n) {
  n === void 0 && (n = Np);
  var i = r[t];
  typeof i == "string" && (e[t] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var kp = {
  ALL: A.ALL,
  VERBOSE: A.VERBOSE,
  DEBUG: A.DEBUG,
  INFO: A.INFO,
  WARN: A.WARN,
  ERROR: A.ERROR,
  NONE: A.NONE
};
function Vp(t, e, r) {
  var n = r[t];
  if (typeof n == "string") {
    var i = kp[n.toUpperCase()];
    i != null && (e[t] = i);
  }
}
function Xp(t) {
  var e = {};
  for (var r in jo) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Vp(n, e, t);
        break;
      default:
        if (bp(n))
          xp(n, e, t);
        else if (Mp(n))
          Gp(n, e, t);
        else if (Dp(n))
          Hp(n, e, t);
        else {
          var i = t[n];
          typeof i < "u" && i !== null && (e[n] = String(i));
        }
    }
  }
  return e;
}
var $p = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Dt() {
  var t = Xp($p);
  return Object.assign({}, jo, t);
}
var jp = "=", fi = ";", Fp = ",";
function Kp(t) {
  var e = t.split(fi);
  if (!(e.length <= 0)) {
    var r = e.shift();
    if (r) {
      var n = r.indexOf(jp);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return e.length > 0 && (a = Be(e.join(fi))), { key: i, value: o, metadata: a };
      }
    }
  }
}
function Yp(t) {
  return typeof t != "string" || t.length === 0 ? {} : t.split(Fp).map(function(e) {
    return Kp(e);
  }).filter(function(e) {
    return e !== void 0 && e.value.length > 0;
  }).reduce(function(e, r) {
    return e[r.key] = r.value, e;
  }, {});
}
var Br;
(function(t) {
  t.AlwaysOff = "always_off", t.AlwaysOn = "always_on", t.ParentBasedAlwaysOff = "parentbased_always_off", t.ParentBasedAlwaysOn = "parentbased_always_on", t.ParentBasedTraceIdRatio = "parentbased_traceidratio", t.TraceIdRatio = "traceidratio";
})(Br || (Br = {}));
var Wp = ",", zp = ["OTEL_SDK_DISABLED"];
function Zp(t) {
  return zp.indexOf(t) > -1;
}
var qp = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Jp(t) {
  return qp.indexOf(t) > -1;
}
var Qp = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS"
];
function th(t) {
  return Qp.indexOf(t) > -1;
}
var Er = 1 / 0, fr = 128, eh = 128, rh = 128, Fo = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: A.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Er,
  OTEL_ATTRIBUTE_COUNT_LIMIT: fr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Er,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: fr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Er,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: fr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: eh,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: rh,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Br.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function nh(t, e, r) {
  if (!(typeof r[t] > "u")) {
    var n = String(r[t]);
    e[t] = n.toLowerCase() === "true";
  }
}
function ih(t, e, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[t] < "u") {
    var o = Number(r[t]);
    isNaN(o) || (o < n ? e[t] = n : o > i ? e[t] = i : e[t] = o);
  }
}
function oh(t, e, r, n) {
  n === void 0 && (n = Wp);
  var i = r[t];
  typeof i == "string" && (e[t] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var ah = {
  ALL: A.ALL,
  VERBOSE: A.VERBOSE,
  DEBUG: A.DEBUG,
  INFO: A.INFO,
  WARN: A.WARN,
  ERROR: A.ERROR,
  NONE: A.NONE
};
function sh(t, e, r) {
  var n = r[t];
  if (typeof n == "string") {
    var i = ah[n.toUpperCase()];
    i != null && (e[t] = i);
  }
}
function uh(t) {
  var e = {};
  for (var r in Fo) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        sh(n, e, t);
        break;
      default:
        if (Zp(n))
          nh(n, e, t);
        else if (Jp(n))
          ih(n, e, t);
        else if (th(n))
          oh(n, e, t);
        else {
          var i = t[n];
          typeof i < "u" && i !== null && (e[n] = String(i));
        }
    }
  }
  return e;
}
var _h = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function xr() {
  var t = uh(_h);
  return Object.assign({}, Fo, t);
}
var mt;
(function(t) {
  t[t.SUCCESS = 0] = "SUCCESS", t[t.FAILED = 1] = "FAILED";
})(mt || (mt = {}));
var ch = (
  /** @class */
  function() {
    function t() {
      var e = this;
      this._promise = new Promise(function(r, n) {
        e._resolve = r, e._reject = n;
      });
    }
    return Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolve = function(e) {
      this._resolve(e);
    }, t.prototype.reject = function(e) {
      this._reject(e);
    }, t;
  }()
), Eh = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, fh = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, dh = (
  /** @class */
  function() {
    function t(e, r) {
      this._callback = e, this._that = r, this._isCalled = !1, this._deferred = new ch();
    }
    return Object.defineProperty(t.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.call = function() {
      for (var e, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((e = this._callback).call.apply(e, fh([this._that], Eh(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, t;
  }()
), lh = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ko = 1e4, Th = 5, ph = 1e3, hh = 5e3, vh = 1.5;
function Sh(t) {
  t === void 0 && (t = {});
  var e = {};
  return Object.entries(t).forEach(function(r) {
    var n = lh(r, 2), i = n[0], o = n[1];
    typeof o < "u" ? e[i] = String(o) : d.warn('Header "' + i + '" has invalid value (' + o + ") and will be ignored");
  }), e;
}
function Oh(t, e) {
  return t.endsWith("/") || (t = t + "/"), t + e;
}
function Ah(t) {
  try {
    var e = new URL(t);
    return e.pathname === "" && (e.pathname = e.pathname + "/"), e.toString();
  } catch {
    return d.warn("Could not parse export URL: '" + t + "'"), t;
  }
}
function Rh(t) {
  return typeof t == "number" ? t <= 0 ? Yo(t, Ko) : t : mh();
}
function mh() {
  var t, e = Number((t = xr().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && t !== void 0 ? t : xr().OTEL_EXPORTER_OTLP_TIMEOUT);
  return e <= 0 ? Yo(e, Ko) : e;
}
function Yo(t, e) {
  return d.warn("Timeout must be greater than 0", t), e;
}
function Lh(t) {
  var e = [429, 502, 503, 504];
  return e.includes(t);
}
function yh(t) {
  if (t == null)
    return -1;
  var e = Number.parseInt(t, 10);
  if (Number.isInteger(e))
    return e > 0 ? e * 1e3 : -1;
  var r = new Date(t).getTime() - Date.now();
  return r >= 0 ? r : 0;
}
var gh = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {}), this._sendingPromises = [], this.url = this.getDefaultUrl(e), typeof e.hostname == "string" && (this.hostname = e.hostname), this.shutdown = this.shutdown.bind(this), this._shutdownOnce = new dh(this._shutdown, this), this._concurrencyLimit = typeof e.concurrencyLimit == "number" ? e.concurrencyLimit : 30, this.timeoutMillis = Rh(e.timeoutMillis), this.onInit(e);
    }
    return t.prototype.export = function(e, r) {
      if (this._shutdownOnce.isCalled) {
        r({
          code: mt.FAILED,
          error: new Error("Exporter has been shutdown")
        });
        return;
      }
      if (this._sendingPromises.length >= this._concurrencyLimit) {
        r({
          code: mt.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      this._export(e).then(function() {
        r({ code: mt.SUCCESS });
      }).catch(function(n) {
        r({ code: mt.FAILED, error: n });
      });
    }, t.prototype._export = function(e) {
      var r = this;
      return new Promise(function(n, i) {
        try {
          d.debug("items to be sent", e), r.send(e, n, i);
        } catch (o) {
          i(o);
        }
      });
    }, t.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, t.prototype.forceFlush = function() {
      return Promise.all(this._sendingPromises).then(function() {
      });
    }, t.prototype._shutdown = function() {
      return d.debug("shutdown started"), this.onShutdown(), this.forceFlush();
    }, t;
  }()
), Ph = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ht = (
  /** @class */
  function(t) {
    Ph(e, t);
    function e(r, n, i) {
      var o = t.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return e;
  }(Error)
), Me = function() {
  return Me = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Me.apply(this, arguments);
}, Nh = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ih(t, e, r, n, i) {
  if (navigator.sendBeacon(e, new Blob([t], r)))
    d.debug("sendBeacon - can send", t), n();
  else {
    var o = new Ht("sendBeacon - cannot send " + t);
    i(o);
  }
}
function bh(t, e, r, n, i, o) {
  var a, s, u = !1, _ = setTimeout(function() {
    if (clearTimeout(a), u = !0, s.readyState === XMLHttpRequest.DONE) {
      var E = new Ht("Request Timeout");
      o(E);
    } else
      s.abort();
  }, n), c = function(E, f) {
    E === void 0 && (E = Th), f === void 0 && (f = ph), s = new XMLHttpRequest(), s.open("POST", e);
    var T = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    Object.entries(Me(Me({}, T), r)).forEach(function(l) {
      var S = Nh(l, 2), R = S[0], h = S[1];
      s.setRequestHeader(R, h);
    }), s.send(t), s.onreadystatechange = function() {
      if (s.readyState === XMLHttpRequest.DONE && u === !1)
        if (s.status >= 200 && s.status <= 299)
          d.debug("xhr success", t), i(), clearTimeout(_), clearTimeout(a);
        else if (s.status && Lh(s.status) && E > 0) {
          var l = void 0;
          f = vh * f, s.getResponseHeader("Retry-After") ? l = yh(s.getResponseHeader("Retry-After")) : l = Math.round(Math.random() * (hh - f) + f), a = setTimeout(function() {
            c(E - 1, f);
          }, l);
        } else {
          var S = new Ht("Failed to export with XHR (status: " + s.status + ")", s.status);
          o(S), clearTimeout(_), clearTimeout(a);
        }
    }, s.onabort = function() {
      if (u) {
        var l = new Ht("Request Timeout");
        o(l);
      }
      clearTimeout(_), clearTimeout(a);
    }, s.onerror = function() {
      if (u) {
        var l = new Ht("Request Timeout");
        o(l);
      }
      clearTimeout(_), clearTimeout(a);
    };
  };
  c();
}
var Ch = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), we = function() {
  return we = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, we.apply(this, arguments);
}, Mh = (
  /** @class */
  function(t) {
    Ch(e, t);
    function e(r, n, i) {
      r === void 0 && (r = {});
      var o = t.call(this, r) || this;
      return o._useXHR = !1, o._serializer = n, o._contentType = i, o._useXHR = !!r.headers || typeof navigator.sendBeacon != "function", o._useXHR ? o._headers = Object.assign({}, Sh(r.headers), Yp(xr().OTEL_EXPORTER_OTLP_HEADERS)) : o._headers = {}, o;
    }
    return e.prototype.onInit = function() {
    }, e.prototype.onShutdown = function() {
    }, e.prototype.send = function(r, n, i) {
      var o = this, a;
      if (this._shutdownOnce.isCalled) {
        d.debug("Shutdown already started. Cannot send objects");
        return;
      }
      var s = (a = this._serializer.serializeRequest(r)) !== null && a !== void 0 ? a : new Uint8Array(), u = new Promise(function(c, E) {
        o._useXHR ? bh(s, o.url, we(we({}, o._headers), { "Content-Type": o._contentType }), o.timeoutMillis, c, E) : Ih(s, o.url, { type: o._contentType }, c, E);
      }).then(n, i);
      this._sendingPromises.push(u);
      var _ = function() {
        var c = o._sendingPromises.indexOf(u);
        o._sendingPromises.splice(c, 1);
      };
      u.then(_, _);
    }, e;
  }(gh)
);
function di(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 97 && t <= 102 ? t - 87 : t - 55;
}
function un(t) {
  for (var e = new Uint8Array(t.length / 2), r = 0, n = 0; n < t.length; n += 2) {
    var i = di(t.charCodeAt(n)), o = di(t.charCodeAt(n + 1));
    e[r++] = i << 4 | o;
  }
  return e;
}
var wh = 9, Dh = Math.pow(10, wh);
function Uh(t) {
  return t[0] * Dh + t[1];
}
function Wo(t) {
  var e = BigInt(1e9);
  return BigInt(t[0]) * e + BigInt(t[1]);
}
function Bh(t) {
  var e = Number(BigInt.asUintN(32, t)), r = Number(BigInt.asUintN(32, t >> BigInt(32)));
  return { low: e, high: r };
}
function zo(t) {
  var e = Wo(t);
  return Bh(e);
}
function xh(t) {
  var e = Wo(t);
  return e.toString();
}
var Gh = typeof BigInt < "u" ? xh : Uh;
function li(t) {
  return t;
}
function Zo(t) {
  if (t !== void 0)
    return un(t);
}
var Hh = {
  encodeHrTime: zo,
  encodeSpanContext: un,
  encodeOptionalSpanContext: Zo
};
function kh(t) {
  var e, r;
  if (t === void 0)
    return Hh;
  var n = (e = t.useLongBits) !== null && e !== void 0 ? e : !0, i = (r = t.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? zo : Gh,
    encodeSpanContext: i ? li : un,
    encodeOptionalSpanContext: i ? li : Zo
  };
}
var Vh = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Xh(t) {
  return {
    name: t.name,
    version: t.version
  };
}
function Fe(t) {
  return Object.keys(t).map(function(e) {
    return qo(e, t[e]);
  });
}
function qo(t, e) {
  return {
    key: t,
    value: Jo(e)
  };
}
function Jo(t) {
  var e = typeof t;
  return e === "string" ? { stringValue: t } : e === "number" ? Number.isInteger(t) ? { intValue: t } : { doubleValue: t } : e === "boolean" ? { boolValue: t } : t instanceof Uint8Array ? { bytesValue: t } : Array.isArray(t) ? { arrayValue: { values: t.map(Jo) } } : e === "object" && t != null ? {
    kvlistValue: {
      values: Object.entries(t).map(function(r) {
        var n = Vh(r, 2), i = n[0], o = n[1];
        return qo(i, o);
      })
    }
  } : {};
}
function $h(t, e) {
  var r, n = t.spanContext(), i = t.status;
  return {
    traceId: e.encodeSpanContext(n.traceId),
    spanId: e.encodeSpanContext(n.spanId),
    parentSpanId: e.encodeOptionalSpanContext(t.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: t.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: t.kind == null ? 0 : t.kind + 1,
    startTimeUnixNano: e.encodeHrTime(t.startTime),
    endTimeUnixNano: e.encodeHrTime(t.endTime),
    attributes: Fe(t.attributes),
    droppedAttributesCount: t.droppedAttributesCount,
    events: t.events.map(function(o) {
      return Fh(o, e);
    }),
    droppedEventsCount: t.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: t.links.map(function(o) {
      return jh(o, e);
    }),
    droppedLinksCount: t.droppedLinksCount
  };
}
function jh(t, e) {
  var r;
  return {
    attributes: t.attributes ? Fe(t.attributes) : [],
    spanId: e.encodeSpanContext(t.context.spanId),
    traceId: e.encodeSpanContext(t.context.traceId),
    traceState: (r = t.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: t.droppedAttributesCount || 0
  };
}
function Fh(t, e) {
  return {
    attributes: t.attributes ? Fe(t.attributes) : [],
    name: t.name,
    timeUnixNano: e.encodeHrTime(t.time),
    droppedAttributesCount: t.droppedAttributesCount || 0
  };
}
function Kh(t) {
  return {
    attributes: Fe(t.attributes),
    droppedAttributesCount: 0
  };
}
var Yh = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Wh = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function zh(t, e) {
  var r = kh(e);
  return {
    resourceSpans: qh(t, r)
  };
}
function Zh(t) {
  var e, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = Yh(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, s = n.get(a.resource);
      s || (s = /* @__PURE__ */ new Map(), n.set(a.resource, s));
      var u = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), _ = s.get(u);
      _ || (_ = [], s.set(u, _)), _.push(a);
    }
  } catch (c) {
    e = { error: c };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function qh(t, e) {
  for (var r = Zh(t), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = Wh(o.value, 2), s = a[0], u = a[1], _ = [], c = u.values(), E = c.next(); !E.done; ) {
      var f = E.value;
      if (f.length > 0) {
        var T = f.map(function(S) {
          return $h(S, e);
        });
        _.push({
          scope: Xh(f[0].instrumentationLibrary),
          spans: T,
          schemaUrl: f[0].instrumentationLibrary.schemaUrl
        });
      }
      E = c.next();
    }
    var l = {
      resource: Kh(s),
      scopeSpans: _,
      schemaUrl: void 0
    };
    n.push(l), o = i.next();
  }
  return n;
}
var Jh = {
  serializeRequest: function(t) {
    var e = zh(t, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(e));
  },
  deserializeResponse: function(t) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(t));
  }
}, Qh = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Qo = "v1/traces", tv = "http://localhost:4318/" + Qo, ev = (
  /** @class */
  function(t) {
    Qh(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, r, Jh, "application/json") || this;
      return n._headers = Object.assign(n._headers, Pp(Dt().OTEL_EXPORTER_OTLP_TRACES_HEADERS)), n;
    }
    return e.prototype.getDefaultUrl = function(r) {
      return typeof r.url == "string" ? r.url : Dt().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? Ah(Dt().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT) : Dt().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? Oh(Dt().OTEL_EXPORTER_OTLP_ENDPOINT, Qo) : tv;
    }, e;
  }(Mh)
);
class rv extends ev {
  constructor(e) {
    super(e), this._beaconSender = typeof navigator < "u" && navigator.sendBeacon ? go : void 0, this._xhrSender = yo, this._onAttributesSerializing = e.onAttributesSerializing || Lo;
  }
  send(e, r) {
    var n;
    if (this._shutdownOnce.isCalled) {
      d.debug("Shutdown already started. Cannot send objects");
      return;
    }
    e = e.map((o) => (o.attributes = this._onAttributesSerializing ? this._onAttributesSerializing(o.attributes, o) : o.attributes, o));
    const i = (n = this._serializer.serializeRequest(e)) !== null && n !== void 0 ? n : new Uint8Array();
    document.hidden && this._beaconSender && i.length <= 64e3 ? this._beaconSender(this.url, i, { type: "application/json" }) : this._xhrSender(this.url, i, Object.assign({
      // These headers may only be necessary for otel's collector,
      // need to test with actual ingest
      Accept: "application/json",
      "Content-Type": "application/json"
    }, this.headers)), r();
  }
}
const Ti = "browser_instance_id";
class Gr {
  static get id() {
    if (this._id !== null)
      return this._id;
    let e = GT(Ti);
    return e ? this._id = e : e === null ? (e = tn(64), this._id = e, HT(Ti, e)) : this._id = void 0, this._id;
  }
}
Gr._id = null;
function nv(t) {
  return ["cookie", "localStorage"].includes(t);
}
const iv = new RegExp(" daum[ /]| deusu/| yadirectfetcher|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\btime/|^<|^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^email|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^igetter/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/5\\.0\\s[a-z\\.-]+$|^mozilla/\\d\\.\\d \\(compatible;?\\)$|^mozilla/\\d\\.\\d \\w*$|^navermailapp|^netsurf|^offline|^openai/|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|^{{.*}}$|adscanner/|analyzer|archive|ask jeeves/teoma|audit|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|cookiehubscan|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|exaleadcloudview|feed|firephp|functionize|gomezagent|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|images|infrawatch|insight|inspect|iplabel|ips-agent|java(?!;)|jsjcw_scanner|library|linkcheck|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|optimize|pageburst|pagespeed|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|reputation|resolver|retriever|rexx;|rigor|rss\\b|scanner\\.|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|tools|torrent|trace|transcoder|url|validator|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|zgrab", "i");
function ov(t) {
  return !!t && iv.test(t);
}
class av {
  constructor(e) {
    this.options = e;
  }
  shouldSample(e, r, n, i, o, a) {
    return Mo(), this.options.decider.shouldSample(e, r, n, i, o, a);
  }
  toString() {
    return `SplunkSampler{decider=${this.options.decider.toString()}}`;
  }
}
const ve = {
  disableBots: !1,
  disableAutomationFrameworks: !1,
  applicationName: "unknown-browser-app",
  beaconEndpoint: void 0,
  bufferTimeout: 4e3,
  //millis, tradeoff between batching and loss of spans by not sending before page close
  bufferSize: 50,
  // spans, tradeoff between batching and hitting sendBeacon invididual limits
  instrumentations: {},
  exporter: {
    factory: (t) => t.otlp ? new rv(t) : new OT(t)
  },
  persistence: "cookie",
  spanProcessor: {
    factory: (t, e) => new ao(t, e)
  },
  rumAccessToken: void 0
};
function fe(t, e, r) {
  e in t && !(r in t && t[r] !== ve[r]) && (t[r] = t[e]);
}
function sv(t) {
  return fe(t, "app", "applicationName"), fe(t, "beaconUrl", "beaconEndpoint"), fe(t, "environment", "deploymentEnvironment"), fe(t, "rumAuth", "rumAccessToken"), t;
}
const ta = [
  { Instrument: Yd, confKey: "document", disable: !1 },
  { Instrument: gl, confKey: "xhr", disable: !1 },
  { Instrument: fT, confKey: "interactions", disable: !1 },
  { Instrument: $o, confKey: "postload", disable: !1 },
  { Instrument: oT, confKey: "fetch", disable: !1 },
  { Instrument: ZT, confKey: "websocket", disable: !0 },
  { Instrument: Xo, confKey: "longtask", disable: !1 },
  { Instrument: Po, confKey: en, disable: !1 },
  { Instrument: _p, confKey: "visibility", disable: !0 },
  { Instrument: Ep, confKey: "connectivity", disable: !0 },
  { Instrument: mp, confKey: "socketio", disable: !0 }
];
ta.map((t) => t.confKey).reduce((t, e) => (t[e] = !1, t), { webvitals: !1 });
function uv(t) {
  var e;
  return !((e = t.exporter) === null || e === void 0) && e.otlp ? `https://rum-ingest.${t.realm}.signalfx.com/v1/rumotlp` : `https://rum-ingest.${t.realm}.signalfx.com/v1/rum`;
}
function _v(t) {
  const e = t.beaconEndpoint + (t.rumAccessToken ? "?auth=" + t.rumAccessToken : "");
  return t.exporter.factory({
    url: e,
    otlp: t.exporter.otlp,
    onAttributesSerializing: t.exporter.onAttributesSerializing
  });
}
let Et = !1, Ut, Bt, dr, ft, U;
const cv = {
  DEFAULT_AUTO_INSTRUMENTED_EVENTS: Qr,
  DEFAULT_AUTO_INSTRUMENTED_EVENT_NAMES: cT,
  // Re-export samplers as properties for easier use in CDN build
  AlwaysOnSampler: rt,
  AlwaysOffSampler: Pt,
  ParentBasedSampler: pe,
  SessionBasedSampler: Op,
  _processedOptions: null,
  get inited() {
    return Et;
  },
  _internalInit: function(t) {
    cv.init(Object.assign(Object.assign({}, ve), t));
  },
  init: function(t) {
    var e, r;
    if ("OTEL_TRACES_EXPORTER" in qt || (qt.OTEL_TRACES_EXPORTER = "none"), Et) {
      console.warn("SplunkRum already initialized.");
      return;
    }
    if (d.setLogger(new Ai(), t != null && t.debug ? A.DEBUG : A.WARN), !VT(this))
      return;
    if (typeof window != "object") {
      d.error("SplunkRum: Non-browser environment detected, aborting");
      return;
    }
    if (typeof Symbol != "function") {
      d.error("SplunkRum: browser not supported, disabling instrumentation.");
      return;
    }
    if (t.disableBots && ov(navigator.userAgent)) {
      this.disabledByBotDetection = !0, d.error("SplunkRum will not be initialized, bots are not allowed.");
      return;
    }
    if (t.disableAutomationFrameworks && navigator.webdriver) {
      this.disabledByAutomationFrameworkDetection = !0, d.error("SplunkRum will not be initialized, automation frameworks are not allowed.");
      return;
    }
    U = new Tp();
    const i = Object.assign({}, ve, sv(t), {
      exporter: Object.assign({}, ve.exporter, t.exporter)
    });
    if (!nv(i.persistence)) {
      d.error(`Invalid persistence flag: The value for "persistence" must be either "cookie", "localStorage", or omitted entirely, but was: ${i.persistence}`);
      return;
    }
    if (this._processedOptions = i, i.realm && (i.beaconEndpoint ? d.warn("SplunkRum: Realm value ignored (beaconEndpoint has been specified)") : i.beaconEndpoint = uv(i)), !i.debug) {
      if (i.beaconEndpoint) {
        if (!i.beaconEndpoint.startsWith("https") && !i.allowInsecureBeacon)
          throw new Error("Not using https is unsafe, if you want to force it use allowInsecureBeacon option.");
      } else throw new Error("SplunkRum.init( {beaconEndpoint: 'https://something'} ) is required.");
      i.rumAccessToken || d.warn("rumAccessToken will be required in the future");
    }
    const o = tn(64), { ignoreUrls: a, applicationName: s, deploymentEnvironment: u, version: _ } = i, c = { ignoreUrls: a, enabled: !1 }, E = Object.assign(Object.assign({}, $t), {
      [Mn.TELEMETRY_SDK_NAME]: "@splunk/otel-web",
      [Mn.TELEMETRY_SDK_VERSION]: D,
      // Splunk specific attributes
      "splunk.rumVersion": D,
      "splunk.scriptInstance": o,
      app: s
    });
    Gr.id && (E["browser.instance.id"] = Gr.id);
    const f = vp();
    f && (E[hp] = f), this.resource = new Lr(E);
    const T = new lp(Object.assign(Object.assign({}, i.tracer), { resource: this.resource, sampler: new av({
      decider: (r = (e = i.tracer) === null || e === void 0 ? void 0 : e.sampler) !== null && r !== void 0 ? r : new rt(),
      allSpansAreActivity: this._processedOptions._experimental_allSpansExtendSession
    }) }));
    Bt = WT(i.persistence, T, U, i.cookieDomain, !!t._experimental_allSpansExtendSession).deinit;
    const l = ta.map(({ Instrument: R, confKey: h, disable: g }) => {
      const C = Xn(i.instrumentations[h], c, g);
      if (C) {
        const z = R === Xo ? new R(C, t) : (
          // @ts-expect-error Can't mark in any way that processedOptions.instrumentations[confKey] is of specifc config type
          new R(C)
        );
        return h === en && z instanceof Po && (dr = z), h === "postload" && z instanceof $o && (ft = z), z;
      }
      return null;
    }).filter((R) => !!R);
    if (this.attributesProcessor = new Sp(Object.assign(Object.assign(Object.assign({}, u ? { environment: u, "deployment.environment": u } : {}), _ ? { "app.version": _ } : {}), i.globalAttributes || {})), T.addSpanProcessor(this.attributesProcessor), i.beaconEndpoint) {
      const R = _v(i), h = i.spanProcessor.factory(R, {
        scheduledDelayMillis: i.bufferTimeout,
        maxExportBatchSize: i.bufferSize
      });
      T.addSpanProcessor(h), this._processor = h;
    }
    i.debug && T.addSpanProcessor(new P_(new L_())), window.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && this._processor.forceFlush();
    }), T.register({
      contextManager: new pp(Object.assign(Object.assign({}, i.context), { onBeforeContextStart: () => ft == null ? void 0 : ft.onBeforeContextChange(), onBeforeContextEnd: () => ft == null ? void 0 : ft.onBeforeContextChange() }))
    }), Ut = as({
      tracerProvider: T,
      instrumentations: l
    }), this.provider = T;
    const S = Xn(i.instrumentations.webvitals);
    S !== !1 && sp(T, S), Et = !0, d.info("SplunkRum.init() complete");
  },
  deinit(t = !1) {
    var e;
    !Et && !t || (Ut == null || Ut(), Ut = void 0, Bt == null || Bt(), Bt = void 0, (e = this.provider) === null || e === void 0 || e.shutdown(), delete this.provider, U = void 0, d.disable(), XT(), Et = !1);
  },
  setGlobalAttributes(t) {
    var e, r;
    (e = this.attributesProcessor) === null || e === void 0 || e.setGlobalAttributes(t), U == null || U.emit("global-attributes-changed", {
      attributes: ((r = this.attributesProcessor) === null || r === void 0 ? void 0 : r.getGlobalAttributes()) || {}
    });
  },
  getGlobalAttributes() {
    var t;
    return ((t = this.attributesProcessor) === null || t === void 0 ? void 0 : t.getGlobalAttributes()) || {};
  },
  _experimental_getGlobalAttributes() {
    return this.getGlobalAttributes();
  },
  error(...t) {
    if (!Et) {
      d.debug("SplunkRum not inited");
      return;
    }
    if (!dr) {
      d.error("Error was reported, but error instrumentation is disabled.");
      return;
    }
    dr.report("SplunkRum.error", t);
  },
  addEventListener(t, e) {
    U == null || U.addEventListener(t, e);
  },
  removeEventListener(t, e) {
    U == null || U.removeEventListener(t, e);
  },
  _experimental_addEventListener(t, e) {
    return this.addEventListener(t, e);
  },
  _experimental_removeEventListener(t, e) {
    return this.removeEventListener(t, e);
  },
  getSessionId() {
    if (Et)
      return zT();
  },
  _experimental_getSessionId() {
    return this.getSessionId();
  },
  _internalOnExternalSpanCreated() {
    this._processedOptions && ne({
      forceStore: !1,
      hadActivity: this._processedOptions._experimental_allSpansExtendSession
    });
  }
};
export {
  Op as SessionBasedSampler,
  cv as SplunkRum,
  lp as SplunkWebTracerProvider,
  OT as SplunkZipkinExporter,
  cv as default
};
//# sourceMappingURL=index-CMkvHvN5.js.map
